///////////////////////////////////////////////////////////////////////////////////
// Containers to hold global lookups, variables and configuration
///////////////////////////////////////////////////////////////////////////////////
const CONFIG = {};
const DATA = {};
const SEARCH = {};

///////////////////////////////////////////////////////////////////////////////////
// Data and library imports
///////////////////////////////////////////////////////////////////////////////////
// DOES NOT WORK WITH GULP
// const Promise = require('es6-promise-polyfill').Promise;
// import styles from './homepage.scss';

///////////////////////////////////////////////////////////////////////////////////
// Global configuration
///////////////////////////////////////////////////////////////////////////////////
// map constants
CONFIG.minzoom = 5;
CONFIG.maxzoom = 17;
CONFIG.ymin = 32.534156;
CONFIG.ymax = 42.009518;
CONFIG.xmin = -124.409591;
CONFIG.xmax = -114.131211;
  
CONFIG.sidebarwidth = 380; // Sidebar width from CSS, make sure that it matches
CONFIG.first_load = true; // track app load
CONFIG.load_from_params = window.location.href.indexOf('?') > -1; // a flag for whether or not the incoming URL has params
// max number of results to show from a property search at the top right
// as a reference, searching for the string "Los Angeles" returns 982 results
CONFIG.search_results_max_length = 60;
// the number of characters to type in the search bar before we kick off the "typeahead"
// note: search starts after this number, so on 3 if the number is 2
// note, if more than 5, we can't effectively search for a zip code
CONFIG.typeahead_char_count_to_search = 2;

// marker and other styles
CONFIG.circle_styles = {
  // placed in service
  pis: {
    radius: 4,
    fillColor: '#65a9d4',
    fillOpacity: 1,
    weight: 2,
    color: '#0577be',
    opacity: 1,
  },
  pis_faded: {
    radius: 4,
    fillColor: '#d0e5f2',
    fillOpacity: 1,
    weight: 2,
    color: '#0577be',
    opacity: 0.35,
  },
  // not placed in service
  not_pis: {
    radius: 4,
    fillColor: '#cccccc',
    fillOpacity: 1,
    weight: 2,
    color: '#888888',
    opacity: 1,
  },
  not_pis_faded: {
    radius: 4,
    fillColor: '#efefef',
    fillOpacity: 1,
    weight: 2,
    color: '#888888',
    opacity: 0.35,
  },
  // shouldn't happen, but in case it does
  missing: {
    radius: 16,
    fillColor: '#000',
    fillOpacity: 0.9,
    stroke: false,
  },
  // circle_selected
  circle_selected: {
    radius: 9,
    fillColor: '#e8982d',
    fillOpacity: 1,
    weight: 2,
    color: '#383d4c',
    opacity: 1,
  }
}

CONFIG.selected_district_style = {
  fill: false,
  color: '#444',
  weight: 4,
  opacity: 0.75
}

// to track the selected property or district
CONFIG.selected = {
  dtype: 'california',
  id: 'california',
}

// layer definitions. These are all Mapserver/Tilecache tile layers.
// See initTileLayers() where we create markup and construct L.TileLayer
// to add a layer, configure a Mapserver layer, and add to the list here with a matching layer name
// unfortunately, $trayheight (and show/hide details) will have to be manually adjusted if layers are added or removed
CONFIG.underlays = [
  {
    layer: 'ces', 
    label: 'CalEnviroScreen 4.0', 
    opacity: 0.5, 
    legend: {
      type: 'categorical', 
      labels: ['10%','20%','30%','40%','50%','60%','70%','80%','90%','100%'], 
      styles: [
        {'background-color': 'rgb(0,97,0)'},
        {'background-color': 'rgb(60,128,0)'},
        {'background-color': 'rgb(107,161,0)'},
        {'background-color': 'rgb(164,196,0)'},
        {'background-color': 'rgb(223,235,0)'},
        {'background-color': 'rgb(255,234,0)'},
        {'background-color': 'rgb(255,187,0)'},
        {'background-color': 'rgb(255,145,0)'},
        {'background-color': 'rgb(255,98,0)'},
        {'background-color': 'rgb(255,34,0)'},
      ]
    }
  },
  {
    layer: 'tcac', 
    label: 'TCAC/HCD Opportunity Map', 
    opacity: 0.5, 
    legend: {
      type: 'categorical-vertical', 
      variable: 'rank', 
      labels: [
        'Highest Resource', 
        'High Resource', 
        'Moderate Resource', 
        'Low Resource', 
        'Insufficient Data'], 
      styles: [
        {'background-color': 'rgb(35,78,160)'},
        {'background-color': 'rgb(40,151,191)'},
        {'background-color': 'rgb(115,201,189)'},
        {'background-color': 'rgb(213,238,179)'},
        {'background-color': 'rgb(211,211,211)'},
      ]
    }
  },
  {
    layer: 'hps',
    label: 'TCAC/HCD High Poverty and Segregated',
    opacity: 0.5,
    legend: {
      type: 'categorical-vertical', 
      variable: 'povseg',
      labels: ['High Poverty and Segregated'],
      styles: [
        {
          'background-image': 'url(./static/images/hatch_hps.png)'
        },
      ] 
    }
  },
  {
    layer: 'neighborhoodchange', 
    label: 'HCD Neighborhood Change Map', 
    opacity: 1, 
    legend: {
      type: 'categorical-vertical', 
      labels: ['Neighborhood Change'], 
      styles: [
        {
          'background-image': 'url(./static/images/hatch_neighborhood.png)'
        },
      ] 
    }
  },
  {
    layer: 'foz', 
    label: 'Federal Opportunity Zones', 
    opacity: 0.66, 
    legend: {
      type: 'single', 
      color: '#7f70cc', 
      bordercolor: '#7f70cc' 
    }
  },
  {
    layer: 'fire', 
    label: 'CAL FIRE Fire Hazard Severity Zones', 
    opacity: 0.6, 
    legend: {
      type: 'categorical-vertical', 
      labels: ['Local Responsibility Area – Very High Risk', 'State Responsibility Area – Very High Risk', 'State Responsibility Area – High Risk', 'State Responsibility Area – Moderate Risk'], 
      styles: [
        {'background-color': '#5e1ef3'}, 
        {'background-color': '#ee0000'}, 
        {'background-color': '#dd9300'}, 
        {'background-color': '#fff200'},
      ] 
    }
  },
  {
    layer: 'heat', 
    label: 'FEMA Heat Wave Risk Index', 
    opacity: 0.6, 
    legend: {
      type: 'categorical-vertical', 
      labels: ['Very High Risk', 'Relatively High Risk'], 
      styles: [
        {'background-color': '#c83b54'}, 
        {'background-color': '#e46461'}
      ] 
    }
  },
  {
    layer: 'earthquake', 
    label: 'FEMA Earthquake Risk Index', 
    opacity: 0.6, 
    legend: {
      type: 'categorical-vertical', 
      labels: ['Very High', 'Relatively High'], 
      styles: [
        {'background-color': '#9747d1'}, 
        {'background-color': '#c599e5'}
      ] 
    }
  },
  {
    layer: 'floods', 
    label: 'FEMA National Flood Hazard Layer', 
    opacity: 0.6, 
    legend: {
      // only a single symbol, but with a request to include a label
      type: 'categorical-vertical',
      labels: ['Flood Zones'],
      styles: [{'background-color': '#2271a2', 'border': '1px solid #2271a2'}], 
    }
  },
]

CONFIG.boundaries = [
  {layer: 'counties', label: 'Counties', opacity: 0.85},
  {layer: 'congress', label: 'U.S. Congressional Districts', opacity: 0.85},
  {layer: 'assembly', label: 'State Assembly Districts', opacity: 0.85},
  {layer: 'senate', label: 'State Senate Districts', opacity: 0.85},
]

CONFIG.district_cobenefits = [
  {key: 'median_rent_savings', label: 'Household Rent Savings', format: 'usd_10', unit: 'per month', tooltip: 'Estimate of median monthly rent savings per household from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'total_rent_savings', label: 'Total Rent Savings', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total annual rent savings for all households from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'median_earnings_boost', label: 'Lifetime Earnings Boost', format: 'usd_1000', unit: 'per child housed', tooltip: 'Estimate of long-term, lifetime earnings increase per child who live in affordable housing during childhood. Accounts for additional income boosts if located in a neighborhood whose characteristics have been shown by research to support childhood development and economic mobility<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'pediatric_savings_moving', label: 'Pediatric Health Savings from Living in a Lower Poverty Community', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of the long-term, lifetime cost savings from reduced hospital spending for children living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'pediatric_savings_asthma', label: 'Medical Cost Savings from Reduction in Pediatric Asthma ED Visits', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of short-term medical cost savings from reduced use of emergency department services for the treatment of asthma for children living in deed-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'health_savings', label: 'Medical Cost Savings from Reduction in Severe Obesity and Diabetes', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of medical cost savings from reducing severe obesity and diabetes for adults living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'ghg_transit', label: 'GHG Emission Reductions from Proximity to Transit', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near transit<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'ghg_jobs', label: 'GHG Emission Reductions from Proximity to Jobs', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near job centers<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'total_jobs', label: 'Jobs Supported', format: 'number_100', unit: 'per year', tooltip: 'Estimate of total jobs supported by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'total_income', label: 'Wages and Business Income Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total wages and business income generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
  {key: 'taxes_generated', label: 'State and Local Taxes Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total state and local taxes generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>'},
]
// Property cobenefit definitions. Used on the sidebar and in the CSV download 
CONFIG.property_cobenefits = [
  {key: 'rent_savings', label: 'Household Rent Savings', format: 'usd_10', unit: 'per month', tooltip: 'Estimate of median monthly rent savings per household from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'total_rent_savings', label: 'Total Rent Savings', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total annual rent savings for all households from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'earnings_boost', label: 'Lifetime Earnings Boost', format: 'usd_1000', unit: 'per child housed', tooltip: 'Estimate of long-term, lifetime earnings increase per child who live in affordable housing during childhood. Accounts for additional income boosts if located in a neighborhood whose characteristics have been shown by research to support childhood development and economic mobility<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'pediatric_savings_moving', label: 'Pediatric Health Savings from Living in a Lower Poverty Community', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of the long-term, lifetime cost savings from reduced hospital spending for children living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'pediatric_savings_asthma', label: 'Medical Cost Savings from Reduction in Pediatric Asthma ED Visits', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of short-term medical cost savings from reduced use of emergency department services for the treatment of asthma for children living in deed-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'health_savings', label: 'Medical Cost Savings from Reduction in Severe Obesity and Diabetes', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of medical cost savings from reducing severe obesity and diabetes for adults living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'ghg_transit', label: 'GHG Emission Reductions from Proximity to Transit', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near transit<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'ghg_jobs', label: 'GHG Emission Reductions from Proximity to Jobs', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near job centers<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'total_jobs', label: 'Jobs Supported', format: 'number_100', unit: 'per year', tooltip: 'Estimate of total jobs supported by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'total_income', label: 'Wages and Business Income Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total wages and business income generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'taxes_generated', label: 'State and Local Taxes Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total state and local taxes generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
]

// Calculator cobenefit definitions. Used in the sidebar and in the CSV download
CONFIG.calculator_cobenefits = [
  {key: 'monthly_rent_savings', label: 'Household Rent Savings', format: 'usd_10', unit: 'per household', tooltip: 'Estimate of median monthly rent savings per household from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_rent_savings', label: 'Total Rent Savings', format: 'usd_millions', unit: 'per property', tooltip: 'Estimate of total annual rent savings for all households from living in rent-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'lifetime_earnings', label: 'Lifetime Earnings Boost', format: 'usd_1000', unit: 'per child housed', tooltip: 'Estimate of long-term, lifetime earnings increase per child who live in affordable housing during childhood. Accounts for additional income boosts if located in a neighborhood whose characteristics have been shown by research to support childhood development and economic mobility<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_pediatric_savings_moving', label: 'Pediatric Health Savings from Living in a Lower Poverty Community', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of the long-term, lifetime cost savings from reduced hospital spending for children living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_pediatric_savings_asthma', label: 'Medical Cost Savings from Reduction in Pediatric Asthma ED Visits', format: 'usd_millions_thousands_tens', unit: 'per year', tooltip: 'Estimate of short-term medical cost savings from reduced use of emergency department services for the treatment of asthma for children living in deed-restricted affordable housing<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_health_savings', label: 'Medical Cost Savings from Reduction in Severe Obesity and Diabetes', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of medical cost savings from reducing severe obesity and diabetes for adults living in deed-restricted affordable housing in low-poverty neighborhoods<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'ghg_transit', label: 'GHG Emission Reductions from Proximity to Transit', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near transit<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'ghg_jobs', label: 'GHG Emission Reductions from Proximity to Jobs', format: 'number_etc', unit: 'MTCO<sub>2</sub>e per year', tooltip: 'Estimate of greenhouse gas (GHG) emission reductions from locating deed-restricted affordable housing near job centers<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },  
  {key: 'annual_jobs', label: 'Jobs Supported', format: 'number_100', unit: 'per year', tooltip: 'Estimate of total jobs supported by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_income', label: 'Wages and Business Income Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total wages and business income generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
  {key: 'annual_taxes', label: 'State and Local Taxes Generated', format: 'usd_millions', unit: 'per year', tooltip: 'Estimate of total state and local taxes generated by the construction and occupation of multifamily homes<br><span>For more information, see the <a href="https://calhousingpartnership.org/wp-content/uploads/2026/03/Affordable-Housing-Map-Benefits-Calculator-Methodology-2024.pdf" target="_blank">full methodology documentation</a></span>' },
]

// this array is used to create a table of property attributes on the property sidebar
// see updatePropertySidebar()
// set nodata to false to hide missing attributes
// protected attributes (noted below), cannot show unless logged in as staff or admin
// the endpoint is also protected, so these will not be returned unless authenticated, and because nodata is false, nothing will show
CONFIG.property_attributes = [
  {key: 'housing_type', label: 'Housing Type', format: 'string', nodata: 'Data not available', tooltip: 'Identifies the population to be served by a development'},
  {key: 'construction_type', label: 'Construction Type', format: 'string', nodata: 'Data not available', tooltip: 'Identifies whether a development received funding prior to construction (“New Construction”) or in order to rehabilitate an existing property (“Acquisition/Rehabilitation”)'},
  {key: 'year_placed_in_service', label: 'Placed in Service', format: 'pis', nodata: 'Not yet in service', tooltip: 'Identifies when a development has been completed and is operating under its regulatory agreement or contract'},
  {key: 'affordability_term_ends', protected: true, label: 'Affordability Term Ends', format: 'string', nodata: false, tooltip: 'Estimated year that the regulatory agreement governing affordability on the development ends.'}, // protected
  {key: 'risk_level', protected: true, label: 'Risk of Conversion', format: 'string', nodata: false, tooltip: 'The Partnership has analyzed conversion patterns among the state’s stock of subsidized affordable housing to identify the homes most at risk of converting to market rate, and categorized each affordable development into one of four groups: low risk, moderate risk, high risk, and very high risk.'}, // protected
  {key: 'affordable_units', label: 'Affordable Homes', format: 'number', nodata: 'Data not available', tooltip: 'Number of homes in the development designated as affordable to low-income households, excluding market-rate and manager units'},
  {key: 'owner_developer', protected: true, label: 'Owner or Developer', format: 'string', nodata: false, tooltip: 'Owner or developer of the affordable development. Because this information is usually collected by a state or federal affordable housing program at the time of application, it might not reflect the most current ownership.'}, // protected
  {key: 'units', label: 'Total Homes', format: 'number', nodata: 'Data not available', tooltip: 'Total number of homes in the development, both affordable and market-rate'},
  {key: 'units_30_ami', label: 'Units at or below 30% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_35_ami', label: 'Units at 35% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_40_ami', label: 'Units at 40% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_45_ami', label: 'Units at 45% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_50_ami', label: 'Units at 50% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_55_ami', label: 'Units at 55% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'units_60_ami', label: 'Units at 60% AMI', format: 'number', nodata: false, tooltip: ''},
  {key: 'tax_credit_type', label: 'Tax Credit Type', format: 'string', nodata: 'Not applicable', tooltip: 'Identifies whether the property is financed using 4% or 9% Low-Income Housing Tax Credits (LIHTC)'},
  {key: 'hud_financing_name', label: 'HUD Financing Program', format: 'string', nodata: 'Not applicable', tooltip: 'The U.S. Department of Housing and Urban Development (HUD) is a federal agency that supports community development and homeownership, enforces the Fair Housing Act, and oversees programs to assist low-income and underserved households with their housing needs'},
  {key: 'usda_financing_name', label: 'USDA Financing Program', format: 'string', nodata: 'Not applicable', tooltip: 'The U.S. Department of Agriculture (USDA) is a federal agency that offers loans, grants, and loan guarantees to support economic development and housing in rural communities'},
  {key: 'hcd_financing_name', label: 'HCD Financing Program', format: 'string', nodata: 'Not applicable', tooltip: 'The California Department of Housing and Community Development (HCD) is a state government agency that oversees a number of programs and allocates loans and grants to preserve and expand affordable housing opportunities and promote strong communities throughout California'},
  {key: 'calhfa_financing_name', label: 'CalHFA Financing Program', format: 'string', nodata: 'Not applicable', tooltip: 'The California Housing Finance Agency (CalHFA) is California’s affordable housing bank that provides financing and programs that support affordable housing opportunities for low- to moderate-income households'},
  {key: 'stateassembly', label: 'Assembly District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://findyourrep.legislature.ca.gov/">CA Legislature</a>'},
  {key: 'statesenate', label: 'Senate District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://findyourrep.legislature.ca.gov/">CA Legislature</a>'},
  {key: 'congress', label: 'U.S. Congressional District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.house.gov/representatives/find-your-representative">US Congress</a>'},
  {key: 'calenviroscreen', label: 'CalEnviro Screen 4.0', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://oehha.ca.gov/calenviroscreen/report/calenviroscreen-40">CalEnviroScreen</a>'},
  {key: 'tcac_opportunity', label: 'TCAC/HCD Opportunity Map', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.treasurer.ca.gov/ctcac/opportunity.asp">TCAC</a>'},
  {key: 'fed_opportunity', label: 'Federal Opportunity Zone', format: 'boolean', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.irs.gov/credits-deductions/businesses/opportunity-zones">Opportunity Zones</a>'},
  {key: 'calfire', label: 'CalFire Zone', format: 'string', nodata: 'Not Applicable', tooltip: 'For more information, see <a href="https://osfm.fire.ca.gov/what-we-do/community-wildfire-preparedness-and-mitigation/fire-hazard-severity-zones">CAL FIRE</a>.'},
  {key: 'fema_heat', label: 'FEMA Heatwave Risk', format: 'string', nodata: 'Not Applicable', tooltip: 'For more information, see <a href="https://hazards.fema.gov/nri/">FEMA</a>.'},
  {key: 'fema_earthquake', label: 'FEMA Earthquake Risk', format: 'string', nodata: 'Not Applicable', tooltip: 'For more information, see <a href="https://hazards.fema.gov/nri/">FEMA</a>.'},
  {key: 'fema_flood', label: 'FEMA Flood Risk', format: 'string', nodata: 'Not Applicable', tooltip: 'For more information, see <a href="https://www.fema.gov/flood-maps/national-flood-hazard-layer">FEMA</a>.'}
]

// as above, but for districts
// not used
// CONFIG.district_attributes = [
//   {key: 'lihtc_count', subkey: 'total', label: 'LIHTC Total', format: 'number', nodata: 'Not applicable'},
//   {key: 'hud_count', subkey: 'total', label: 'HUD Total', format: 'number', nodata: 'Not applicable'},
//   {key: 'usda_count', subkey: 'total', label: 'USDA Total', format: 'number', nodata: 'Not applicable'},
//   {key: 'financing_count', subkey: 'total', label: 'Total', format: 'number', nodata: 'Not applicable'},
//   // TODO FOR NEW FUNDING CATS
//   {key: 'hcd_count', subkey: 'total', label: 'Total', format: 'number', nodata: 'Not applicable'},
//   {key: 'calhfa_count', subkey: 'total', label: 'Total', format: 'number', nodata: 'Not applicable'},
// ]

// as above, but for the calculator
CONFIG.calculator_attributes = [
  {key: 'construction_type', label: 'Construction Type', format: 'string', nodata: 'Data not available', tooltip: 'Identifies whether a development received funding prior to construction (“New Construction”) or in order to rehabilitate an existing property (“Acquisition/Rehabilitation”)'},
  {key: 'affordable_units', label: 'Affordable Homes', format: 'number', nodata: 'Data not available', tooltip: 'Number of homes in the development designated as affordable to low-income households, excluding market-rate and manager units'},
  {key: 'units', label: 'Total Homes', format: 'number', nodata: 'Data not available', tooltip: 'Total number of homes in the development, both affordable and market-rate'},
  {key: 'stateassembly', label: 'Assembly District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://findyourrep.legislature.ca.gov/">CA Legislature</a>'},
  {key: 'statesenate', label: 'Senate District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="http://www.legislature.ca.gov/legislators_and_districts/legislators_and_districts.html">CA Legislature</a>'},
  {key: 'congress', label: 'U.S. Congressional District', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.house.gov/representatives/find-your-representative">US Congress</a>'},
  {key: 'calenviroscreen', label: 'CalEnviro Screen 4.0', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://oehha.ca.gov/calenviroscreen/report/calenviroscreen-40">CalEnviroScreen</a>'},
  {key: 'tcac_opportunity', label: 'TCAC/HCD Opportunity Map', format: 'string', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.treasurer.ca.gov/ctcac/opportunity.asp">TCAC</a>'},
  {key: 'fed_opportunity', label: 'Federal Opportunity Zone', format: 'boolean', nodata: 'Data not available', tooltip: 'For more information, see <a href="http://www.dof.ca.gov/Forecasting/Demographics/opportunity_zones/index.html">Opportunity Zones</a>'},
  // {key: 'ab_1550', label: 'AB 1550 Low-Income Community', format: 'boolean', nodata: 'Data not available', tooltip: 'For more information, see <a href="https://www.arb.ca.gov/cc/capandtrade/auctionproceeds/communityinvestments.htm">AB 1550</a>'},
]

// district summary data will only be calculated when requested, and will be cached here
DATA.district_sums = {
  'california': {},
  'county': {},
  'city': {},
  'congress': {},
  'statesenate': {},
  'stateassembly': {},
  'owner_developer': {},
}

// a flag to know if we are using runserver or not
CONFIG.is_dev = document.location.href.indexOf(':8000') != -1;

// set the url to the WMS resources
// everthing is tilecache for now, see initTileLayers where we switch to straight Mapserver on dev
CONFIG.tilecache = 'https://affordablehomes.calhousingpartnership.org/cgi-bin/tilecache.cgi/1.0.0/';


// String formatting functions
CONFIG.format = {
  'usd': function(n) {return '$' + parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})},
  'usd_10': function(n) { 
    // round to nearest 10
    return '$' + (Math.round(n / 10) * 10).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}) 
  },
  'usd_1000': function(n) { 
    // round to nearest 1000
    return '$' + (Math.round(n / 1000) * 1000).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}) 
  },
  'usd_millions': function(n) { 
    // differential rounding if gt 1M or lt 1M:
    // If greater than $1M, nearest million ($xxx,000,000); if less than $1M, nearest thousand ($xx,000)
    let z = +n > 1000000 ? 1000000 : 1000;  
    return '$' + (Math.round(n / z) * z).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
   },
  'usd_millions_thousands_tens': function(n) { 
    // differential rounding if gt 1M or lt 1M, or lt 1000:
    // If greater than $1M, nearest million ($xxx,000,000); if between 1,000 and $1M, nearest thousand ($xx,000); if less than 1,000, nearest 10 ($xx0)
    let z = 1000000;
    if (+n < 1000000) z = 1000;
    if (+n < 1000) z = 10;
    return '$' + (Math.round(n / z) * z).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
   },
  'number': function(n) {
    if (isNaN(n) || n === null) {
      return '0';
    } else {
      return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    }
  },
  'number_100': function(n) {
    // differential rounding if gt 100 or lt 100
    // If greater than 100, nearest 10 (xx0); if less than 100, don’t round.
    let z = +n > 100 ? 10 : 1;
    return (Math.round(n / z) * z).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
  },
  'number_etc': function(m) {
    // differential rounding, depending
    // If greater than 1M, nearest million (xxx,000,000); 
    // if between 1,000 and 1M, nearest thousand (xx,000); 
    // if between 100 and 1,000, nearest 10 (xx0); 
    // if between 1 and 100, nearest 1 (xxx); 
    let n = +m;
    let z = 1000000;
    if (n < 1000000) z = 1000;
    if (n < 1000) z = 10;
    if (n < 100) z = 1;
    let value = (Math.round(n / z) * z).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    // if less than 1, nearest hundredths (0.xx).
    if (n < 1) {
      value = n.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
    return value;
  },
  'float': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})},
  'none': function(n) {return n},
  'string': function(n) {return n},
  'boolean': function(n) { return n == 0 ? 'No' : 'Yes' },
  'assembly': function(d) { return DATA.stateassembly_lookup[d].name},
  'senate': function(d) { return DATA.statesenate_lookup[d].name},
  'congress': function(d) { return DATA.congress_lookup[d].name},
  'pis': function(d) { return parseInt(d) > 2015 ? `${d} (estimate)` : d },
}

// Ready!
$(document).ready(function () {
  // data initialization first, then the remaining init steps
  Promise.all([
      initData('./data/property_data/'),
      initData('./data/county_data/'),
      initData('./data/city_data/'),
      initData('./data/congress_data/'),
      initData('./data/senate_data/'),
      initData('./data/assembly_data/'),
      initData('./data/developer_data/'), 
    ])
    .then(function(data) {
      initDataFormat(data);         // data formatting, manipulation
      initLeafletShims();           // init map shims, e.g. fitBoundsWithOffset()
      initMap();                    // init the map, load the housing circles, and init the map view
      initTileLayers();             // init the tile layers on the map, and the controls for these on the sidebar
      initButtons();                // init many, but not all button and button-like behaviors
      initSidebarMarkup();          // init sidebar markup from CONFIG. Do this once at startup, then reuse later
      initDistrictSearch();         // init sidebar district search
      initPropertySearch();         // init search objects, and search controls on the map
      initPropertySearchIndices();  // init the search indices
      initMapFilters();             // init the radio buttons to filter the map display
      initCalculator();             // init property calculator specific functionality
      initTooltips();               // init Tippy tooltips that have been defined in HTML

      // and kick things off with an initial data load for CA
      getDistrictSums().done(function() {
        initApp();
      });
  });
});


///////////////////////////////////////////////////////////////////////////////////
// Functions called on Doc ready
///////////////////////////////////////////////////////////////////////////////////

// Basic data init, returns a promise
function initData(url) {
  // get the topojson
  // while we could import this, doing so makes build time slow, and also generates a huge index.js, and also makes tree shaking slow
  // wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
  return new Promise(function(resolve, reject) {
    $.get(url, function(data) {
      resolve(data);
    });
  });
}

function initDataFormat(data) {
  // Properties: get a raw data object from CSV
  let rawdata = Papa.parse(data[0], {
    header: true,
    skipEmptyLines: 'greedy',
    // trim whitespace from each cell
    transform: function(r) {return r.trim()}
  });
  DATA.rawdata = rawdata.data;
  // parse out the properties into a more convenient lookup structure
  DATA.property_lookup = {};
  DATA.rawdata.forEach(function(d) {
    if (! d.latitude || ! d.longitude) return; // shouldn't happen, but if we can't map it, let's not keep it
    // create a property lookup
    DATA.property_lookup[d.id] = d;

    // create and save easy-to-use boolean values for funding types
    d.hud = d.hud_financing_name ? true : false;
    d.usda = d.usda_financing_name ? true : false;
    d.lihtc = d.tax_credit_type ? true : false;
    d.hcd = d.hcd_financing_name ? true : false; 
    d.calhfa = d.calhfa_financing_name ? true : false;
  });

  // Counties: get a raw data object from CSV
  let county = Papa.parse(data[1], { header: true, skipEmptyLines: 'greedy' });
  // get a simple list of counties, and a lookup to use for search results
  // parse out the county data into a more structure for Select2
  // and a lookup to handle search results
  DATA.county = [];
  DATA.county_lookup = {};
  county.data.forEach(function(d) {
    // create a congress lookup for search results
    DATA.county_lookup[d.gid] = d;
    // and a data structure to index for lunr searching
    DATA.county.push({
      key: `county-${d.gid}`,
      text: `${d.name} County`,
    })
  });

  // Cities: get a raw data object from CSV
  let city = Papa.parse(data[2], { header: true, skipEmptyLines: 'greedy' });
  // get a simple list of cities, and a lookup to use for search results
  // parse out the city data into a more structure for Select2
  // and a lookup to handle search results
  DATA.city = [];
  DATA.city_lookup = {};
  city.data.forEach(function(d) {
    // create a city lookup for search results
    DATA.city_lookup[d.gid] = d;
    let tag = d.citytype == 'cdp' ? '(CDP)' : '(city)';
    DATA.city_lookup[d.gid]['tag'] = tag;
    // and a data structure to index for lunr searching
    DATA.city.push({
      key: `city-${d.gid}`,
      text: `${d.name} ${tag}`,
    })
  });

  // Congress: get a raw data object from CSV
  let congress = Papa.parse(data[3], { header: true, skipEmptyLines: 'greedy' });
  // parse out the congress data into a more structure for Select2
  // and a lookup to handle search results
  DATA.congress = [];
  DATA.congress_lookup = {};
  congress.data.forEach(function(d) {
    // create a congress lookup for search results
    // per #118 remove leg names
    d.name = 'Congressional District ' + d.dist_int;
    DATA.congress_lookup[d.dist_int] = d;
    // and a data structure to index for lunr searching
    DATA.congress.push({
      key: `congress-${d.dist_int}`,
      text: d.name,
    })
  });

  // Senate: get a raw data object from CSV
  let senate = Papa.parse(data[4], { header: true, skipEmptyLines: 'greedy' });
  // parse out the senate data into a more structure for Select2
  // and a lookup to handle search results
  DATA.senate = [];
  DATA.statesenate_lookup = {};
  senate.data.forEach(function(d) {
    // create a senate lookup for search results
    // per #118 remove leg names
    d.name = 'Senate District ' + d.dist_int;
    DATA.statesenate_lookup[d.dist_int] = d;
    // and a data structure to index for lunr searching
    DATA.senate.push({
      key: `statesenate-${d.dist_int}`,
      text: d.name,
    })
  });

  // Assembly: get a raw data object from CSV
  let assembly = Papa.parse(data[5], { header: true, skipEmptyLines: 'greedy' });
  // parse out the assembly data into a more structure for Select2
  // and a lookup to handle search results
  DATA.assembly = [];
  DATA.stateassembly_lookup = {};
  assembly.data.forEach(function(d) {
    // create an assembly lookup for search results
    // per #118 remove leg names
    d.name = 'Assembly District ' + d.dist_int;
    DATA.stateassembly_lookup[d.dist_int] = d;
    // and a data structure to index for lunr searching
    DATA.assembly.push({
      key: `stateassembly-${d.dist_int}`,
      text: d.name,
    })
  });

  // Developer: get a raw data object from CSV
  // non-authenticated users get only an empty string
  let developer = Papa.parse(data[6], { header: true, skipEmptyLines: 'greedy' });
  DATA.owner_developer = [];
  DATA.owner_developer_lookup = {};
  // We will only have data if the user is authenticated, otherwise the endpoint returns an empty string
  if (developer.data.length) {
    developer.data.forEach(function(d) {
      // create an developer lookup for search results
      DATA.owner_developer_lookup[d.id] = d;
      // and a data structure to index for lunr searching
      DATA.owner_developer.push({
        key: `owner_developer-${d.id}`,
        text: d.name,
      })
    })
  }
}

// check for params in the address bar, and parse them as needed
function initApp() {
  // check for "URL params" and use them to init the map
  if (CONFIG.load_from_params) {
    // parse and apply the params
    applyStateParams();
  } else {
    // no params, fit to the default bounds
    CONFIG.map.fitBoundsWithOffset(CONFIG.homebounds);
    CONFIG.ca_border.addTo(CONFIG.map);

    // draw the properties on the map
    addHousingPropertiesToMap(true, false); 

    // kick things off by selecting California
    $('select#district-select').val('california-california').trigger('change');
  }

  // Always do these final steps: we don't want the application of state params to trigger this callback
  // when the map changes position or zoom, update the query params
  // sadly, it seems we can only register callbacks on map a single event - so everything has to be included here
  setTimeout(function() {
    CONFIG.map.on('zoomend moveend', function() {
      // update stateful URL
      updateSearchParams();

      // hide or show border tile layer on zoom level 8
      let zoom = CONFIG.map.getZoom();
      if (zoom > 7) {
        CONFIG.ca_border.setOpacity(0)
      } else {
        CONFIG.ca_border.setOpacity(1)
      }
    });

    // no longer the first load
    CONFIG.first_load = false;
  }, 500)

  // Hack: close the map layer panel on smaller screens
  // See #228
  if ( $(window).width() < 1580 ) $('div#layers-button').click();

  // all set
  $('div#loading').hide();
}

// various map inits
function initMap() {
  // the map init
  CONFIG.map = L.map('map', {
    preferCanvas: true,
    zoomControl: false,
    minZoom: CONFIG.minzoom,
    maxZoom: CONFIG.maxzoom
  });

  // add the (one and only) basemap
  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_29e2_1_169174723ddbb4d9deb6dbaf', {
    attribution: '&copy; <a target="_blank" href="http://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a> &copy <a href="https://carto.com/attributions#basemaps" target="_blank">CARTO</a>'
  }).addTo(CONFIG.map);

  // add a Calfornia state outline, but don't add it yet
  CONFIG.ca_border = L.tileLayer(CONFIG.tilecache +  'california/{z}/{x}/{y}.png?type=google', { opacity: 1 });

  // add attribution and credits
  new L.controlCredits({
    image: '/static/map/greeninfo.png',
    link: 'https://www.greeninfo.org/',
    text: 'Interactive mapping<br/>by GreenInfo Network',
    position: 'bottomright',
  }).addTo(CONFIG.map);

  // add an empty feature group to hold district highlights
  CONFIG.selected_district = L.featureGroup([]).addTo(CONFIG.map);

  // create a feature group for housing properties
  CONFIG.housing_properties = L.featureGroup([]).addTo(CONFIG.map);

  // get the default/starting bounds from the set of properties
  // we'll fit the map to this in initApp()
  CONFIG.homebounds = [[CONFIG.ymin, CONFIG.xmin],[CONFIG.ymax, CONFIG.xmax]];
  CONFIG.district_bounds = CONFIG.homebounds; // true at first for CA, may not be so later

  // now that we have our bounds defined, add the zoom control
  new L.Control.ZoomBar({
    homeBounds: CONFIG.homebounds,
    position: 'topright'
  }).addTo(CONFIG.map);
}

// init the overlays, underlays, other map layers, everything but the property circles, those are in initMap()
function initTileLayers() {
  // add the markup for the "data underlays"
  // and while we are there, init the Leaflet WMS layer
  var target = $('div#underlay-wrapper');
  CONFIG.underlays.forEach(function(underlay, i) {
    var form = $('<div>', { 'class': 'form-check' }).appendTo(target);
    var input = $('<input>', {
      'class': 'form-check-input',
      'type': 'radio',
      'name': 'underlays',
      'id': `underlay-${i}`,
      'value': underlay.layer,
    }).appendTo(form);
    $('<label>', {
      'class': 'form-check-label',
      'for': `underlay-${i}`,
      'text': underlay.label
    }).appendTo(form);

    // add a legend, only shows when sibling radio is checked
    var outer = $('<div>', {'class': 'legend-outer'}).appendTo(form);
    var legend = $('<div>', {'class': 'legend-wrapper'}).appendTo(outer);
    var labels = $('<div>', {'class': 'label-wrapper'}).appendTo(outer);
    switch (underlay.legend.type) {
      // at the moment these both work with the same case
      // but they could diverge if needed
      case 'continuous':
      case 'categorical':
        underlay.legend.styles.forEach(function(d) {
          var swatch = $('<div>', {
            'class': 'legend-continuous',
          })
          var opacity = underlay.opacity;
          var styles = d;
          d.opacity = opacity;
          swatch.css(styles).appendTo(legend);
        })
        underlay.legend.labels.forEach(function(d) {
          $('<span>', {
            'class': 'label-continuous',
            'text': d,
          }).appendTo(labels);
        })
        break;
      case 'categorical-vertical':
        legend.addClass('flex-column');
        underlay.legend.styles.forEach(function(d, i) {
          let wrapper = $('<div>', { 'class': 'legend-vertical-wrapper' }).appendTo(legend);
          let swatch = $('<div>', {
            'class': 'legend-continuous-vertical',
          });
          var opacity = underlay.opacity;
          var styles = d;
          d.opacity = opacity;
          swatch.css(styles).appendTo(wrapper);
          $('<span>', {
            'class': 'label-continuous-vertical',
            'text': underlay.legend.labels[i],
          }).appendTo(wrapper);
        });
        break;
      case 'single':
        $('<div>', {
          'class': 'legend-single',
        }).css({'background-color': underlay.legend.color, 'opacity': underlay.opacity, 'border': `1px solid ${underlay.legend.bordercolor}`}).appendTo(legend)
        .appendTo(legend);
        break;
    }

    // init the Leaflet layer
    let opacity = underlay.opacity;
    underlay.tilelayer = CONFIG.is_dev ?
    L.tileLayer.wms('https://affordablehomes.calhousingpartnership.org:8000/mapserver/', { layers: underlay.layer, transparent: 'TRUE', format: 'image/png', opacity: opacity }) : 
    L.tileLayer(CONFIG.tilecache + underlay.layer + '/{z}/{x}/{y}.png?type=google', { opacity: opacity });
  });

  // add the markup for the "boundaries"
  // and while we are there, init the Leaflet WMS layer
  var target = $('div#boundary-wrapper');
  CONFIG.boundaries.forEach(function(boundary, i) {
    var form = $('<div>', { 'class': 'form-check' }).appendTo(target);
    var input = $('<input>', {
      'class': 'form-check-input',
      'type': 'radio',
      'name': 'boundaries',
      'id': `boundary-${i}`,
      'value': boundary.layer,
    }).appendTo(form);
    $('<label>', {
      'class': 'form-check-label',
      'for': `boundary-${i}`,
      'text': boundary.label
    }).appendTo(form);

    // init the Leaflet layer
    let opacity = boundary.opacity;
    boundary.tilelayer = CONFIG.is_dev ? 
      L.tileLayer.wms('https://affordablehomes.calhousingpartnership.org:8000/mapserver/', { layers: boundary.layer, transparent: 'TRUE', format: 'image/png', opacity: opacity }) : 
      L.tileLayer(CONFIG.tilecache + boundary.layer + '/{z}/{x}/{y}.png?type=google', { opacity: opacity });
  });

  // init the radio controls to turn off and on the various layers
  // Underlays
  $('input[name="underlays"]').on('change', function() {
    let check = $('input[name="underlays"]:checked');
    let layer = check.val();
    CONFIG.underlays.forEach(function(underlay) {
      if (underlay.layer == layer) {
        CONFIG.map.addLayer(underlay.tilelayer);
      } else {
        CONFIG.map.removeLayer(underlay.tilelayer);
      }
    });
    // show the sibling legend, hide the others
    $('div.legend-outer').hide();
    $(this).parent().find('div.legend-outer').show();

    // update state params to track this change
    updateSearchParams();

    // track the event with GA
    let label = check.siblings('label').text();
    ga('send', 'event', 'Map Layer', label);
  });

  // Boundaries
  $('input[name="boundaries"]').on('change', function() {
    let check = $('input[name="boundaries"]:checked')
    let layer = check.val();
    CONFIG.boundaries.forEach(function(boundary) {
      if (boundary.layer == layer) {
        CONFIG.map.addLayer(boundary.tilelayer);
      } else {
        CONFIG.map.removeLayer(boundary.tilelayer);
      }
    });

    // update state params to track this change
    updateSearchParams();
    
    // track the event with GA
    let label = check.siblings('label').text();
    ga('send', 'event', 'Map Layer', label);
  });

  // init the "clear layers" buttons
  $('div#map-layers-panel span.clear').on('click', function() {
    var target = $(this).data().clear;
    // clear the layers from the map
    CONFIG[target].forEach(function(layer) {
      CONFIG.map.removeLayer(layer.tilelayer);
    });
    // uncheck the radios
    $('input[name="' + target + '"]').prop('checked', false).trigger('change')
    // hide the legends, only if in the 'underlays' section (now called tracts)
    if (target == 'underlays') $('div.legend-outer').hide();
  });

  // final step: Get CA json on board, so it's available when we need it for PDF reports
  $.getJSON('./static/ca_geojson.json', {}, function(result) {
    CONFIG.ca_json = result;
  });

}

// Leaflet-specific shims
function initLeafletShims() {
  // extend L.Map.fitBounds to account for an offset from the sidebar
  L.Map.prototype.fitBoundsWithOffset = function (bounds, options) {
    var notmobile = ! isMobile;
    var sidebarvisible = $('div#sidebar').offset().left >= 0;
    if (notmobile && sidebarvisible) {
      options = { paddingTopLeft: [CONFIG.sidebarwidth, 0] };
    }
    return this.fitBounds(bounds, options);
  };

  // extend L.Map.setView to account for an offset from the sidebar
  L.Map.prototype.setViewWithOffset = function (latlng, zoom) {
    var notmobile = ! isMobile;
    var sidebarvisible = $('div#sidebar').offset().left >= 0;
    if (notmobile && sidebarvisible) {
      var sidebar_width = $('div#sidebar').width();
      var targetPoint = CONFIG.map.project(latlng, zoom).subtract([sidebar_width / 2, 0]);
      latlng = CONFIG.map.unproject(targetPoint, zoom);
    }
    return this.setView(latlng, zoom);
  }
}

// district search provides county, district, and region options on the sidebar
// the search control is managed by Select2
function initDistrictSearch() {
  // Using the Select2 data array throws errors, oh well
  // create the options from our district data
  let target = $('#district-select');
  // add California
  $('<optgroup>', {label: 'California'}).appendTo(target);
  $('<option>', { text: 'California', value: 'california-california' }).appendTo(target);
  // add the rest of the districts
  let optlabels = ['Counties', 'Cities', 'US Congress', 'California Senate', 'California Assembly'];

  // sort by labels
  let county    = DATA.county.sort(function(a, b)  { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });
  let congress  = DATA.congress.sort(function(a, b)  { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });
  let senate    = DATA.senate.sort(function(a, b)    { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });
  let assembly  = DATA.assembly.sort(function(a, b)  { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });
  let city      = DATA.city.sort(function(a, b)      { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });
  let developer = DATA.owner_developer.sort(function(a, b) { return a.text.localeCompare(b.text, undefined, {numeric: true, sensitivity: 'base'}) });

  [county, city, congress, senate, assembly, developer].forEach(function(dataset, i) {
  $('<optgroup>', {label: optlabels[i]}).appendTo(target);
    dataset.forEach(function(d) {
      $('<option>', {
        text: d.text,
        value: d.key,
      }).appendTo(target);
    });
  });

  // now init the select with Select2
  $('select#district-select').select2({
    placeholder: 'Select an option',
  });

  // define what happens when the district select options is selected
  $('select#district-select').on('change', function() {
    // first, per #277, check all checkboxes in the funding/rural filters
    // this helps avoid the outcome of 0 results because a single checkbox is unchecked
    $('input[name="funding_status"]:checkbox').prop('checked', true);
    $('input[name="rural_status"]:checkbox').prop('checked', true);

    let placeid = this.value;
    showPlaceSearchResults(placeid, 'district');

    // track the event with GA:
    // the geography selected
    let keys = placeid.split('-');
    let type = keys[0];
    let id = keys[1];
    let name = getNameFromTypeAndPlaceID(type, id);
    ga('send', 'event', 'Geography Picker', `Category clicked: ${type}`, `Geography: ${name}`);
  });
}

// init a search object on the data, and init the search controls and buttons
function initPropertySearch() {
  // first off, make sure clicks and drags don't propagate to the Map
  let search_div = document.getElementById('property-search');
  let legend_div = document.getElementById('legend');
  L.DomEvent.disableClickPropagation(search_div);
  L.DomEvent.disableClickPropagation(legend_div);

  // Search UI:
  // a roll-your-own "typeahead" based on Fuse
  // https://github.com/krisk/Fuse
  $('div#property-search input').on('keyup',
    // debounced search for places, with typeahead UI
    _.debounce(function() {
      let value = this.value;
      // when we type more than X chars, kick off a search to find matching places
      if (value.length > CONFIG.typeahead_char_count_to_search) {
        findProperty({value: value});
      };

      // hide search results when user clears the selection
      if (!this.value) {
        $('div#property-search-results').hide();
      }
    }, 50)
  );

  // select all text on search input focus
  $('div#search input').on('click', function(e) {
    $(this).select();
  });

  // delegated click handler to define what happens when we click a search result
  $('body').on('click', 'div#search-results div', function() {
    let item = $(this);
    let place = item.data().id;
    showPlaceSearchResults(place, 'property');
    // addendum: close the search results when a result from the list is selected
    $('div#property-search-results').hide();
    // and show the property name in the search bar
    $('div#property-search input').val( item.data().name );
  });

}

function initPropertySearchIndices() {
  // Search init:
  // set up the full text search index for Properties
  SEARCH.property = new Fuse(DATA.rawdata, {
    id: 'id',
    keys: ['name', 'address', 'city', 'zipcode'],
    // shouldSort: true, // doesn't seem to have an effect, surprisingly
    // these two mean that a search for "two words" ONLY returns resuls with that exact string
    // tokenize: true,
    // matchAllTokens: true,
    maxPatternLength: 32,
    minMatchCharLength: CONFIG.typeahead_char_count_to_search,
    // tuning these down from defaults to these levels makes it feel more responsive
    threshold: 0.3,
    location: 0,
    distance: 50,
  });
}

// checkboxes on the sidebar with finance and rural status options
// these filters apply to the map, and also to the display of benefits
function initMapFilters() {
  $('button#filter-submit').on('click', function() {
    // get the list of checked funding and rural status filters
    let filters = $('div#status-and-funding-options input:checkbox').map(function() {
      let self = $(this)
      if (self.is(':checked')) return self.attr('id')
    }).get();

    // Before doing anything else, test that we have selected something, and respond appropriately
    let error = false;
    let message, target = $('div#filter-total-homes-message').empty();
    let funding_checks = $('input[name="funding_status"]:checked').length;
    let status_checks = $('input[name="rural_status"]:checked').length;
    if (! funding_checks && status_checks) {
      message = 'Please select at least one funding program';
      error = true;
    } else if (funding_checks && ! status_checks) {
      message = 'Please select at least one rural status'; 
      error = true;
    } else if (! funding_checks && ! status_checks) {
      message = 'Please make a selection';
      error = true;
    }

    // if we encountered an error, tell the user and return early
    if (error) {
      target.text(message);
      return false;
    } 

    // all good! Carry on...
    getDistrictSums(CONFIG.selected.dtype, CONFIG.selected.id).done(function(data) {
      updateDistrictSidebar(data);
      addHousingPropertiesToMap(true, false);

      if (CONFIG.selected.dtype == 'owner_developer') {
        // if our geography selection is owner_developer, we need to update this on the map as well
        zoomToDistrict('owner_developer', CONFIG.selected.id);
      }

      // update state params to track this change
      updateSearchParams();

      // track the event with GA:
      // the filters that were selected
      let filters = getSelectedFilters();
      let selected = [];
      if (filters.hud == true) selected.push('HUD');
      if (filters.usda == true) selected.push('USDA');
      if (filters.lihtc == true) selected.push('LIHTC');
      if (filters.hcd == true) selected.push('HCD');
      if (filters.calhfa == true) selected.push('CALHFA') 
      if (filters.rural.indexOf('1') > -1) selected.push('Rural');
      if (filters.rural.indexOf('0') > -1) selected.push('Non-rural');
      ga('send', 'event', 'Filter', `Funding Program or Rural Status`, `Selected filters: ${selected.join(', ')}`);
    });
  });
}

// clear any selected marker
function resetMarker() {
  CONFIG.housing_properties.eachLayer(function(layer) {
    // get the selected filters
    if (layer.selected) {
      // found one: unselect and reset it's style
      layer.selected = false;
      let style = layer.properties.placed_in_service == '1' ? CONFIG.circle_styles.pis : CONFIG.circle_styles.not_pis;
      layer.setStyle(style);
    }
  });
}

// calculator specific inits
function initCalculator() {
  // default setting for the pindrop functionality is false
  CONFIG.pindropenabled = false;

  // map interactions: A marker for adding a property, and calculating benefits
  var goldIcon = new L.Icon({
    iconUrl: './static/images/marker-icon-orange.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  CONFIG.map.pinpoint = L.marker([0, 0], { title: "Selected point", draggable: true, icon: goldIcon });

  // map click handler: set the pushpin to get a report
  CONFIG.map.on('click', function (event) {
    if (CONFIG.pindropenabled) {
      pindropSelectPoint(event.latlng);

      // log a GA event
      ga('send', 'event', 'Location Search (calculator)', 'Pin Drop');
    }
  });
  // same for dragging the pinpoint
  CONFIG.map.pinpoint.on('dragend', function () {
    pindropSelectPoint(this.getLatLng());
  });

  // the radio buttons near the top of the calculator, that control the search type
  $('div#location-search input[name="location-search-type"]').on('change', function() {
    let value = $(this).val();
    if (value == 'search-input') {
      // search input is selected, show it
      $('div#location-search-form-wrapper').show();
      // disable the pindrop
      pindropDisable();
    } else {
      // pin drop is enabled, hide the search input
      $('div#location-search-form-wrapper').hide();
      // enable the pindrop
      pindropEnable();
    }
  });

  // the address search input, triggered only by clicking the button
  $('div#location-search-address-input button').on('click', function() {
    const address = $('div#location-search-address-input input').val().trim();
    if (! address) return;
    searchAddress(address);

    // log a GA event
    ga('send', 'event', 'Location Search (calculator)', 'Address Search');
  });


  // highlight the entire field when clicking in
  $('#calculator input').on('focus', function() {
    $(this).select();
  }).on('mouseup', function(e) {
    // prevents the browser from placing the blinking cursor at a specific character position, which would otherwise deselect your newly highlighted text.
    // But only pprevent default if the click happened outside the "step" arrow region (left of the arrows)
    // 30 pixels is generally safe to cover the width of native spinner arrows
    if (e.offsetX < ($(this).outerWidth() - 30)) {
      e.preventDefault();
    }
  });

  // you have to enter at least 1 unit, 1 affordable unit with a rent

  // the calculator form submit action itself
  $("form#calculator").submit(function(e) {
    $('div#loading').show();      

    // check that there is something in the census tract text, indicating that a location has been found
    // this is not fail-safe. The user could have something here from a previous geolocation
    if ( $('span#census-tract').text() == '' ) {
      alert('Have you located your property? Please click the search button next to the address field, then try again.');
      $('div#loading').hide();
      return false;
    }

    // additional error checking: must enter at least one each of total and affordable units
    if ( $('input#total_units').val() <= 0 || $('input#affordable_units').val() <= 0 ) {
      alert('Please enter at least one total unit and one affordable unit.');
      $('div#loading').hide();
      return false;
    }

    // additional error checking: must enter at least one apartment type
    if ( $('input#0_units').val() <= 0 && $('input#1_units').val() <= 0 && $('input#2_units').val() <= 0 && $('input#3_units').val() <= 0 && $('input#4_units').val() <= 0 && $('input#5_units').val() <= 0 ) {
      alert('Please enter at least one unit in an apartment type (Studio, 1-bedroom, etc.).');
      $('div#loading').hide();
      return false;
    }

    // additional error checking: must enter at least one rent
    if ( $('input#0_rent').val() <= 0 && $('input#1_rent').val() <= 0 && $('input#2_rent').val() <= 0 && $('input#3_rent').val() <= 0 && $('input#4_rent').val() <= 0 && $('input#5_rent').val() <= 0 ) {
      alert('Please enter at least one estimated rent for one apartment type');
      $('div#loading').hide();
      return false;
    }

    // additional error checking: must enter a rent for every apartment type with units
    if ( 
      ($('input#0_units').val() > 0 && $('input#0_rent').val() <= 0 ) || 
      ($('input#1_units').val() > 0 && $('input#1_rent').val() <= 0 ) || 
      ($('input#2_units').val() > 0 && $('input#2_rent').val() <= 0 ) || 
      ($('input#3_units').val() > 0 && $('input#3_rent').val() <= 0 ) || 
      ($('input#4_units').val() > 0 && $('input#4_rent').val() <= 0 ) || 
      ($('input#5_units').val() > 0 && $('input#5_rent').val() <= 0 ) 
    ) {
      alert('Please enter a rent for each apartment type with units specified');
      $('div#loading').hide();
      return false;
    }

    // additional error checking: must enter units for every apartment type with rents
    if ( 
      ($('input#0_units').val() <= 0 && $('input#0_rent').val() > 0 ) || 
      ($('input#1_units').val() <= 0 && $('input#1_rent').val() > 0 ) || 
      ($('input#2_units').val() <= 0 && $('input#2_rent').val() > 0 ) || 
      ($('input#3_units').val() <= 0 && $('input#3_rent').val() > 0 ) || 
      ($('input#4_units').val() <= 0 && $('input#4_rent').val() > 0 ) || 
      ($('input#5_units').val() <= 0 && $('input#5_rent').val() > 0 ) 
    ) {
      alert('Please enter a number of units for each apartment type with a rent specified');
      $('div#loading').hide();
      return false;
    }

    // do not submit the form in the traditional way
    e.preventDefault(); 

    // scroll the sidebar back to the top (requested in #209)
    $('div#sidebar').scrollTop(0);

    // grab a reference to the form
    var form = $(this);

    $.ajax({
      type: "POST",
      url: BASE_URL + 'calculate_benefits/',
      data: form.serialize(), // serializes the form's elements.
      success: function(data) {
        $('div#loading').hide();      
        updateCalculatorResultsSidebar(data);

        // log a GA event, but only to log a few fields 
        let type = $('select#construction_type').val();
        ga('send', 'event', 'Construction Type', type);
       
        // log a GA event, but only to log a few fields
        let zipcode = $('input[name="zipcode"]').val();
        ga('send', 'event', 'Calculator Property', zipcode);
       }
     });
  });
}

// init various app buttons and controls
function initButtons() {
  // toggle the sidebar close with chevrons
  $('div#sidebar-toggle').on('click', function() {
    let div = $(this);
    let toggle = div.find('i.fa');
    if (toggle.hasClass('fa-chevron-left')) {
      let winwidth = $(window).width();
      // toggle behavior is different on mobile than desktop
      let width = isMobile ? winwidth - 25 : CONFIG.sidebarwidth;
      $('div#sidebar-group').css({'left': -width});
      div.attr('title', 'Click to open sidebar');
      toggle.removeClass('fa-chevron-left').addClass('fa-chevron-right');

      if (isMobile) { 
        let factor = winwidth < 500 ? 5 : 15;
        $('.sidebargroup').css({ left: winwidth + factor });
        $('div.login-button').css({ left: winwidth - 10})
      }

    } else {
      $('div#sidebar-group').css({'left': 0});
      div.attr('title', 'Click to close sidebar');
      toggle.removeClass('fa-chevron-right').addClass('fa-chevron-left');
    }
  });

  // behavior of the map layers button on the map: show/hide the map layers panel
  $('div#layers-button').on('click', function() {
    let target = $('div#map-layers-panel');
    let icon = $(this).find('i.fa');
    let shim = $('div#shim');
    if (target.is(':visible')) {
      target.hide();
      icon.removeClass('fa-chevron-down').addClass('fa-chevron-right');
      shim.hide();
    } else {
      target.show();
      icon.removeClass('fa-chevron-right').addClass('fa-chevron-down');
      shim.show();
    }
  });

  // a pair of buttons to toggle between "current properties" and the calculator for "new properties"
  $('div#sidebar-main-button-wrapper button').on('click', function() {
    let button = $(this); 
    if (button.hasClass('selected')) return; // don't do anything if we click the already selected button
    // get the style right for the newly selected button
    $('div#sidebar-main-button-wrapper button').removeClass('selected');
    button.addClass('selected');

    // handle the one that was selected
    let panel = button.data().panel
    switch (panel) {
      case 'current':
        // show/hide the active panel
        $('div.sidebar-panel').removeClass('active');
        $('div#sidebar-benefits').addClass('active');

        // close any lingering popups
        CONFIG.map.closePopup();

        // clear the calculator map pin from the map
        pindropDisable();

        // restyle the legend 
        $('div#legend table td div.circle').removeClass('faded');

        // add, filter, and restyle housing properties to give them the "regular" look
        addHousingPropertiesToMap(true, false);

        break; 

      case 'calculator': 
        // show/hide the active panel
        $('div.sidebar-panel').removeClass('active');
        $('div#sidebar-calculator').addClass('active');
        
        // restyle the legend 
        $('div#legend table td div.circle.pis').addClass('faded');
        $('div#legend table td div.circle.not-pis').addClass('faded');

        // enable map pin from the map
        pindropEnable();

        // add, restyle housing properties to give them a "faded" look
        addHousingPropertiesToMap(false, true);

        break; 

      default: 
        console.log('That button does not exist!');
    }

    // log an event with GA
    // note: this assumes only two panels/modes, if more are added, then this must be extended
    let mode = panel == 'calculator' ? 'New Property Calculator' : 'Existing Properties'
    ga('send', 'event', 'Map Mode', mode)

    // all set! 
    updateSearchParams(); 
  });

  // a simple close button on the property sidebar
  $('div#property-close-panel').on('click', function() {
    // hide sidebar-property, and show sidebar-benefits
    $('div#sidebar-property').removeClass('active');
    $('div#sidebar-benefits').addClass('active');

    resetMarker();
    CONFIG.selected_district.clearLayers();
    updateDistrictSidebar(DATA.district_sums['california']['california']);
    zoomToDistrict('california', 'california'); 
    $('select#district-select').val('california-california').trigger('change.select2'); // sync the select
    updateSearchParams();
    $('div#property-search input').val('');
  });

  // a simple close button on the calculator results sidebar 
  $('div#calculator-result-close-panel').on('click', function() {
    // hide sidebar-property, and show sidebar-benefits
    $('div#sidebar-calculator-results').removeClass('active');
    $('div#sidebar-calculator').addClass('active');
  });

  // Download a CSV export from the selected property 
  $('button#property-csv-download-button').on('click', function() {
    // organize the data, and use Papa to create a csv object from it
    let data = $(this).data().download; 
    let values = [];
    let fields = [];

    // create a set of formatted fields and values 
    // Co-benefits first
    CONFIG.property_cobenefits.forEach(function(d) {
      // get the "unit", use jQuery to strip any HTML tags we may have included
      let unit = $('<div>', {html: d.unit}).text();
      // add the label and unit together to make the header field
      fields.push(`${d.label} ${unit}`);
      // add the formatted value
      let value = data[d.key];
      values.push(CONFIG.format[d.format](value));
    });

    // then attributes
    CONFIG.property_attributes.forEach(function(d) {
      // bail on these, they don't exist
      // note this is just decoration, there won't be values anyway, 
      // but don't even print out the labels
      if (! USER && d.protected) return; 
      // add the label to the field names
      fields.push(d.label);
      // add the formatted value to the values
      let value = data[d.key];
      values.push(CONFIG.format[d.format](value));
    });

    // make and download the CSV
    makeCsvDownload(values, fields, 'Affordable Housing Map & Benefits Property_Data Export.csv');
  });

  // Download a CSV export from the calculator 
  $('button#calculator-csv-download-button').on('click', function() {
    // organize the data, and use Papa to create a csv object from it
    let data = $(this).data().download; 
    let values = []
    let fields = [];

    // create a set of formatted fields and values 
    // Co-benefits first
    CONFIG.calculator_cobenefits.forEach(function(d) { 
      // get the "unit", use jQuery to strip any HTML tags we may have included
      let unit = $('<div>', {html: d.unit}).text();
      // add the label and unit together to make the header field
      fields.push(`${d.label} ${unit}`);
      // add the formatted value
      let value = data[d.key];
      values.push(CONFIG.format[d.format](value));
    });

    // then attributes
    CONFIG.calculator_attributes.forEach(function(d) { 
      // add the label to the field names
      fields.push(d.label);
      // add the formatted value to the values
      let value = data[d.key];
      values.push(CONFIG.format[d.format](value));
    });

    // make and download the CSV
    makeCsvDownload(values, fields, 'Affordable Housing Map & Benefits Calculator_Data Export.csv');
  });

  // Print a PDF report on the selected district/county
  $('button#pdf-download-button').on('click', function() {
    // show the loading spinner and start waiting
    $('div#loading').show();

    // gather the map params from the query
    // and the data for the housing properties, district geojson (if needed), stats, etc.
    let search = new URLSearchParams(window.location.search);
    // get the selection type and id, if any
    let selected = search.get('selected') || 'california,california';
    selected = selected.split(',');
    let distype = selected[0];
    let distid = selected[1];

    // gather various stats for the selected district
    var district_sums, district_name, district_json;
    // district_sums = DATA.district_sums[distype][distid];
    district_name = DATA.district_sums[distype][distid].name;
    district_json = distype == 'california' ? CONFIG.ca_json : CONFIG.district_json;

    // put it all together in params and post
    let params = {
      tract: search.get('tract'),       // map layer if any e.g. CES, TCAC, etc.
      boundary: search.get('boundary'), // map boundary layer if any, e.g. County, Congress, etc.
      distype: distype,                 // selected district type, e.g. 'stateassembly'
      distid: distid,                   // selected distirict id, e.g. '1'               
      district_json: district_json ? JSON.stringify(district_json) : '', // geojson of the selected district, absent for 'owner_developer'
      district_name: district_name, // selected district name         
      district_bounds: JSON.stringify(CONFIG.district_bounds), // district bounds to set the map extent, and in the view, to select properties to pass to the template
    }

    $.post(BASE_URL + 'pdf/', params, function(response) {
      // get the URL from the response, and show it on a modal
      $('div#pdf_url div.modal-body a').attr('href', response);
      $('#pdf_url').modal()

      // all done! hide the loading spinner
      $('div#loading').hide();
    });

    // track the event with GA:
    // the geography of the PDF requested
    ga('send', 'event', 'PDF Download', `Geographic Category: ${distype}`, `Geography: ${district_name}`);

  });

  // an option to close the property search results panel on the map
  $('div#property-search-close').on('click', function() {
    $('div#property-search-results').hide();
  })

  // Delegated event handler on methodology links, to send a GA event
  // after that is sent, the link will open as normal, as we do not preventDefault()
  $('body').on('click', 'a.methods-link', function(e) {
    let category = e.target.dataset.location;
    ga('send', 'event', 'Methodology', category); 
  });

  // Track click on "Return to main site"
  $('a#return-to-chpc').on('click', function() {
    ga('send', 'event', 'Return to home');
  });

}

// init the sidebar markup from CONFIG
// that way we can use the definitions in CONFIG for other things, like CSV downloads, and keep this DRY
function initSidebarMarkup() {
  // District sidebar
  let target = $('div#sidebar-benefits div.cobenefits-wrapper');

  // add an info icon, to serve as a trigger for a tippy tooltip
  let title = $('div#sidebar-benefits div.sidebar-title-block');
  let infospan = $('<i>', {class: 'fa fa-info-circle', 'data-info': 'Social and economic benefits header'}).appendTo(title);
  let html = 'This section uses academic studies to translate affordable housing property characteristics—such as number of homes, length of affordability restrictions, and location of the property—into quantifiable estimates of social, environmental, and economic impact.'
  tippy(infospan[0], {
    content: html,
    trigger: 'click',
    interactive: true,
    allowHTML: true,
    onShown(instance) {
      sendInfoIconGA(instance, 'Sidebar general');
    }
  });

  // append a title and value block for each cobenefit 
  CONFIG.district_cobenefits.forEach(function(d) {
    let section = $('<div>', {class: 'cobenefits-section', 'data-cobenefit': d.key}).appendTo(target);
    let title = $('<div>', {class: 'cobenefits-title', text: d.label}).appendTo(section);

    // add a tooltip, if one is provided
    if (d.tooltip) {
      // add an info icon, to serve as a trigger for a tippy tooltip
      let infospan = $('<i>', {class: 'fa fa-info-circle blue', 'data-info': d.label}).appendTo(title);
      let html = `<b>${d.label}</b>: ${d.tooltip}`;
      tippy(infospan[0], {
        content: html,
        trigger: 'click',
        interactive: true,
        allowHTML: true,
        onShown(instance) {
         sendInfoIconGA(instance, 'District benefits');
        }
      });      
    }
    let value = $('<div>', {class: 'cobenefits-value', html: d.unit}).appendTo(section);
    $('<span>', {'data-cobenefit': d.key}).prependTo(value);
  });

  // Property sidebar
  target = $('div#sidebar-property div.cobenefits-wrapper');
  // append a title and value block for each cobenefit 
  CONFIG.property_cobenefits.forEach(function(d) {
    let section = $('<div>', {class: 'cobenefits-section', 'data-cobenefit': d.key}).appendTo(target);
    let title = $('<div>', {class: 'cobenefits-title', text: d.label}).appendTo(section);
    
    // add a tooltip, if one is provided
    if (d.tooltip) {
      // add an info icon, to serve as a trigger for a tippy tooltip
      let infospan = $('<i>', {class: 'fa fa-info-circle blue', 'data-info': d.label}).appendTo(title);
      let html = `<b>${d.label}</b>: ${d.tooltip}`;
      tippy(infospan[0], {
        content: html,
        trigger: 'click',
        interactive: true,
        allowHTML: true,
        onShown(instance) {
         sendInfoIconGA(instance, 'Property benefits');
        }
      });      
    }
    let value = $('<div>', {class: 'cobenefits-value', html: d.unit}).appendTo(section);
    $('<span>', {'data-cobenefit': d.key}).prependTo(value);
  });

  // Calculator results sidebar
  target = $('div#sidebar-calculator-results div.cobenefits-wrapper');
  // append a title and value block for each cobenefit 
  CONFIG.calculator_cobenefits.forEach(function(d) {
    let section = $('<div>', {class: 'cobenefits-section', 'data-cobenefit': d.key}).appendTo(target);
    let title = $('<div>', {class: 'cobenefits-title', text: d.label}).appendTo(section);
    
    // add a tooltip, if one is provided
    if (d.tooltip) {
      // add an info icon, to serve as a trigger for a tippy tooltip
      let infospan = $('<i>', {class: 'fa fa-info-circle blue', 'data-info': d.label}).appendTo(title);
      let html = `<b>${d.label}</b>: ${d.tooltip}`;
      tippy(infospan[0], {
        content: html,
        trigger: 'click',
        interactive: true,
        allowHTML: true,
        onShown(instance) {
         sendInfoIconGA(instance, 'Calculator benefits');
        }
      });      
    }

    let value = $('<div>', {class: 'cobenefits-value', html: d.unit}).appendTo(section);
    $('<span>', {'data-cobenefit': d.key}).prependTo(value);
  });  
}

function initTooltips() {
  // most tooltips are defined in CONFIG and these do not need to be initialized here
  // the following is only for tooltips marked up in homepage.html

  // not much to it: 
  tippy('.tooltip-sidebar', {
    trigger: 'click',
    interactive: true,
    allowHTML: true,
    onShown(instance) {
     sendInfoIconGA(instance, 'Sidebar general');
    }
  });

  // this one needs a bit different treatment
  tippy('.tooltip-map', {
    trigger: 'click',
    interactive: true,
    allowHTML: true,
    placement: 'right',
    popperOptions: {
      positionFixed: true,
    },
    zIndex: 10001,
    onShown(instance) {
     sendInfoIconGA(instance, 'Map layers');
    }
  })
}

///////////////////////////////////////////////////////////////////////////////////
// Named functions
///////////////////////////////////////////////////////////////////////////////////

// use the Nominatim geocoder to search an address
function searchAddress(address) {
  // The geocoder returns the lat/lng of an address it finds, which can vary from an entered lat/lng
  // therfore, if this appears to be a lat,lng, use it directly
  const latlng_regexp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
  
  if (latlng_regexp.test(address)) {
    // this is a lat/lng, no need to geocode
    let latlng = address.split(',');
    latlng = [parseFloat(latlng[0].trim()), parseFloat(latlng[1].trim())];
    pindropSelectPoint(latlng);
  } else {
    // not a lat/lng, this is probably an address
    const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&bounded=1&viewbox=${CONFIG.xmin},${CONFIG.ymin},${CONFIG.xmax},${CONFIG.ymax}&limit=1&q=${encodeURIComponent(address)}`;

    // call the service
    $.getJSON(url, function(data) {
      if (! data || ! data.length) return alert('Could not find that address! Please try again');
    }).fail(function(){
      alert('Could not find that address! Please try again');
      $('div#calculator-form').hide();
      $('div#location-search-results').hide();
    }).done(function(response) {
      const lng = parseFloat(response[0].lon);
      const lat = parseFloat(response[0].lat);

      if (lat < CONFIG.ymin || lat > CONFIG.ymax || lng < CONFIG.xmin || lng > CONFIG.xmax) {
        return alert('This location seems to be outside of California. Did you include a city name and zip code? Please try again');
      }

      pindropSelectPoint({lat: lat, lng: lng}, address);
    });
  }
}

function pindropSelectPoint(latlng, address='') {
  $('div#loading').show();

  let lat = latlng.lat;
  let lng = latlng.lng;
  pindropEnable();

  // move the map pinpoint to the selected location
  CONFIG.map.pinpoint.setLatLng([lat, lng]);

  // zoom to it
  CONFIG.map.setViewWithOffset([lat, lng], CONFIG.maxzoom - 3);

  // now we look up census tract, zip and county at this latlng, and report those to the user
  $.getJSON(`./calculator_lookups/${lat}/${lng}`, {}, function(result) {
    $('div#loading').hide();

    // update the results shown to the user, 
    $('div#location-search-results span#census-tract').text(result.census);
    $('div#location-search-results span#zipcode').text(result.zipcode);
    $('div#location-search-results span#county').text(result.county);
    // as well as hidden fields for the same, that will be submitted with the form
    $('input[name="zipcode"]').val(result.zipcode);
    $('input[name="county"]').val(result.county);
    $('input[name="census"]').val(result.census);
    $('input[name="lat"]').val(lat);
    $('input[name="lng"]').val(lng);
    $('input[name="address"]').val(address);

    // show the rest of the form
    $('div#calculator-form').show();
    $('div#location-search-results').show();
  });
}

function pindropEnable() {
  if (! CONFIG.map.hasLayer(CONFIG.map.pinpoint ) ) CONFIG.map.addLayer(CONFIG.map.pinpoint);
  $('#map').addClass('crosshair').prop('title', 'Click the map to select your location');
  CONFIG.pindropenabled = true;
}

function pindropDisable() {
  if ( CONFIG.map.hasLayer(CONFIG.map.pinpoint ) ) CONFIG.map.removeLayer(CONFIG.map.pinpoint);
  $('#map').removeClass('crosshair').prop('title', '');
  CONFIG.pindropenabled = false;
}

// add housing properties to the map from DATA.rawdata
function addHousingPropertiesToMap(apply_filters=true, calculator=false) {
  // always start by clearing out existing layers
  CONFIG.housing_properties.clearLayers();

  // if we are applying filters, check the funding and status controls for any selections
  let filter = apply_filters ? getSelectedFilters() : null;

  // Set up the marker styles used below: style chosen depends on if we are adding markers to the calculator view, or not
  let circle_style_pis = calculator ? CONFIG.circle_styles.pis_faded : CONFIG.circle_styles.pis; 
  let circle_style_not_pis = calculator ? CONFIG.circle_styles.not_pis_faded : CONFIG.circle_styles.not_pis; 

  // Likewise, set up the calculator click events, that vary between standard view and calculator view
  let marker_click = calculator ? property_marker_click_calculator : property_marker_click_standard;

  // Go through the data and apply the filters
  DATA.rawdata.forEach(function(d) {
    // if we are filtering based on user selections for funding/rural, apply those filters here
    let match = true;
    if (apply_filters) {
      // check financing filters. If any of these are a match, then we log a match
      let funding_match = false;
      if ( d.hud == filter.hud ) funding_match = true;
      if ( d.usda == filter.usda ) funding_match = true;
      if ( d.lihtc == filter.lihtc ) funding_match = true;
      if ( d.hcd == filter.hcd ) funding_match = true; 
      if ( d.calhfa == filter.calhfa ) funding_match = true; 

      // check rural filter for a match
      let rural_match = filter.rural.indexOf(d.rural) > -1 ? true : false; 

      // if both are true, then we have a match, otherwise, no match
      match = rural_match && funding_match ? true : false;
    }

    // if the property matches our conditions, then continue and make a marker
    if (match) {
      // individual style depends on placed in service (PIS or not PIS)
      let style = d.placed_in_service == '1' ? circle_style_pis : circle_style_not_pis;
      let marker = L.circleMarker([d.latitude, d.longitude], style);
      marker.id = d.id;
      marker.properties = d;
      marker.on('mouseover', function(e) {
        if (!marker.selected) marker.selected = false;
        // track the style before hover, so we can reset on the mouseout
        // that way, we don't have to evaluate which panel is showing, or anything else (calculator panel imposes a different style on map markers)
        this.original_style = {
          color: this.options.color,
          fillColor: this.options.fillColor,
          fillOpacity: this.options.fillOpacity,
          opacity: this.options.opacity,
          radius: this.options.radius,
          weight: this.options.weight,
        }
        // now set the hover style
        this.setStyle(CONFIG.circle_styles.circle_selected);
      });
      marker.on('mouseout', function(e) {
        if (marker.selected) return;
        this.setStyle(this.original_style);
      });
      marker.on('click', marker_click);
      // marker all set and events registered:
      // add this marker the layer group
      CONFIG.housing_properties.addLayer(marker);
    }
  });
}

// Go over all filters and return a structure indicating boolean filter selections
function getSelectedFilters() {
  return {
    rural: $('div#status-and-funding-options input[name="rural_status"]:checked').map(function() { return this.value }).get(), 
    hud: $('div#status-and-funding-options input#fundingstatus_hud').is(':checked') ? true : null,
    usda: $('div#status-and-funding-options input#fundingstatus_usda').is(':checked') ? true : null,
    lihtc: $('div#status-and-funding-options input#fundingstatus_lihtc').is(':checked') ? true : null,
    hcd: $('div#status-and-funding-options input#fundingstatus_hcd').is(':checked') ? true : null,
    calhfa: $('div#status-and-funding-options input#fundingstatus_calhfa').is(':checked') ? true : null,
  }
}

// behavior for marker clicks when viewing "current properties"
function property_marker_click_standard(event) {
  // reset any currenly selected marker
  resetMarker();
  // highlight the new one and update the sidebar
  event.target.setStyle(CONFIG.circle_styles.circle_selected);
  event.target.selected = true;
  updatePropertySidebar(event.target.properties);
  updateSearchParams();

  // track the event with GA
  ga('send', 'event', 'Property Click', `Name: ${event.target.properties.name}, City: ${event.target.properties.cityname}`);

}

function property_marker_click_calculator(event) {
  let marker = event.target;
  let d = marker.properties;
  let html = `<h5>${d.name}</h5>`;
  html += `<div class="popup-address">${d.address}, ${d.cityname}, CA ${d.zipcode}</div>`;
  html += `<div class="popup-housing-type"><span>Housing Type:</span> ${d.housing_type}</div>`;
  html += `<div class="popup-construction-type"><span>Construction Type:</span> ${d.construction_type}</div>`;
  html += `<div class="popup-year"><span>Placed in Service:</span> ${d.year_placed_in_service}</div>`;
  html += `<div class="popup-homes"><span>Affordable Homes:</span> ${d.affordable_units}</div>`;
  event.target.bindPopup(html);
  event.target.openPopup();

  // track the event with GA
  ga('send', 'event', 'Property Click', `Name: ${d.name}, City: ${d.cityname}`);

  // since we clicked a housing marker, stop propogation, 
  // so the click event doesn't trigger moving calculator marker (should it be on the map)
  L.DomEvent.stopPropagation(event);
}

// if the URL contains URL params, parse them and set the application state
// for composing URL params, see updateSearchParams()
function applyStateParams() {
  // use URLSearchParams to get the params
  let params = new URLSearchParams(window.location.search);

  // check for map view, which is {lat,lng,zoom}
  if (params.has('view')) {
    let view = params.get('view')
    let views = view.split(',');
    CONFIG.map.setView([views[0],views[1]],views[2]);
  } else {
    CONFIG.map.fitBoundsWithOffset(CONFIG.homebounds);
  }

  // check for tract param, turn on the layer, legend, etc.
  // we don't want to trigger change (e.g. by clicking the button and trigger('change'))
  // because that triggers updateSearchParams() which can strip out the rest of the URL params
  if (params.has('tract')) {
    let tract = params.get('tract');
    let target = $(`input[name="underlays"][value=${tract}]`)
    target.prop('checked', true);
    target.siblings('div.legend-outer').show();
    CONFIG.underlays.forEach(function(layer) {
      if (layer.layer == tract) CONFIG.map.addLayer(layer.tilelayer);
    });
  }

  // check for boundary param, turn on the layer
  // we don't want to trigger change (e.g. by clicking the button and trigger('change'))
  // because that triggers updateSearchParams() which can strip out the rest of the URL params
  if (params.has('boundary')) {
    let boundary = params.get('boundary');
    let target = $(`input[name="boundaries"][value=${boundary}]`);
    target.prop('checked', true);
    CONFIG.boundaries.forEach(function(layer) {
      if (layer.layer == boundary) CONFIG.map.addLayer(layer.tilelayer);
    });
  }

  // check for rural filter
  // just get the checkboxes in sync for now, filter these on the map in a later step
  if (params.has('rural')) {
    $(`input[name="rural_status"]`).prop('checked', false); // start by unchecking everything
    // then check what is specifically indicated
    let ruralfilter = params.get('rural');
    if (ruralfilter) {
      ruralfilter.split(',').forEach(function(f) {
        $(`input[name="rural_status"][value=${f}]`).prop('checked', true);
      });
    }
  }

  // check for funding filter
  // we don't want to trigger change yet (e.g. by clicking the button and trigger('change'))
  // just get the checkboxes in sync for now, filter these on the map in the next step
  if (params.has('funding')) {
    $(`input[name="funding_status"]`).prop('checked', false); // start by unchecking everything
    // then check what is specifically indicated
    let fundingfilter = params.get('funding');
    if (fundingfilter) {
      fundingfilter.split(',').forEach(function(f) {
        $(`input[name="funding_status"][value=${f}]`).prop('checked', true);
      });
    }
  }

  // check for a selection, e.g. district, property, etc. 
  // note: if we have 'selected' and 'view' params, the 'selected' view will override the view
  // also note: Do this last (or at least after addHousingPropertiesToMap) so that these styles are applied last
  if (params.has('selected')) {
    let distid = params.get('selected').split(',');
    let disttype = distid[0];
    let id = distid[1];
    CONFIG.selected.id = id; 
    CONFIG.selected.dtype = disttype;

    switch (disttype) {
      case 'property':
        addHousingPropertiesToMap(true, false);
        let property = DATA.property_lookup[id];
        zoomToProperty(id);
        break;
      case 'stateassembly':
      case 'statesenate':
      case 'congress':
      case 'county':
      case 'city':
      case 'owner_developer':
        // get the summary stats for this district
        getDistrictSums(disttype, id).done(function(data) {
          addHousingPropertiesToMap(true, false);
          updateDistrictSidebar(data);
          zoomToDistrict(disttype, id);
          $('select#district-select').val(`${disttype}-${id}`).trigger('change.select2'); // sync the select
        })
        break;
      default: 
        console.log(`No such district type: ${disttype}`);
    }
  } else {
    // no selected district, show the default sidebar view
    updateDistrictSidebar(DATA.district_sums['california']['california']);
    CONFIG.ca_border.addTo(CONFIG.map);
  }

  // apply funding/rural status filters to the map, if present, and only present without a 'selected' param (above) 
  // tbh I can't really see a way to have a funding or rural param, without a selected param...
  if ( ( params.has('funding') || params.has('rural')) && ! params.has('selected') ) {
    addHousingPropertiesToMap(true, false);
  }

  // calculator param: Doesn't do anything but open the calculator "page"
  if (params.has('calculator')) {
    // click the calcuator tab
    setTimeout(function() { $('button#btn-calculator').click(); }, 0 * 100);
    // prepare the "Existing Properties" sidebar view, for when someone eventually switches over to that tab
    updateDistrictSidebar(DATA.district_sums['california']['california']);
    CONFIG.ca_border.addTo(CONFIG.map);
  }
}

// given data for a property, update the sidebar
function updatePropertySidebar(d) {
  // keep note of the visible panel
  CONFIG.visible_panel = 'property';
  CONFIG.selected.dtype = 'property';
  CONFIG.selected.id = d.id;

  // hack: very particular order request, in cases of missing data/protected data, see #204
  // start by cloning the list
  let property_attributes = JSON.parse(JSON.stringify(CONFIG.property_attributes)); 
  let owner = d.owner_developer; 
  let affordable = parseInt(d.affordable_units);
  let total = d.units;
  // if we have owner, but affordable units is 0, then they want a different order:
  // owner after total homes if there is no unit affordability data
  if (owner && ! affordable) {
    // find the current index of affordable
    let from = property_attributes.findIndex(function(d) {
      return d.key == 'owner_developer';
    });
    // then find the index of total homes (units)
    let to = property_attributes.findIndex(function(d) {
      return d.key == 'units';
    });
    property_attributes.splice(to, 0, property_attributes.splice(from, 1)[0]);
  }

  // fork here for regular (anonymous) users and authenticated users
  if (USER) {
    // first get our extra protected data
    let extra_data = $.get(`data/extra_property_data/${d.id}`, function(response) {
      // NOTE: A given user can only make 100 of these requests (in all time) before being blocked
      // before doing anything, check for a message that indicates this limit was reached
      // TO DO: What to do here? A blocking alert is not great UX
      // if (response.error == '100 housing property requests') {
      //   alert('You have made too many housing data requests. Please contact CHPC')
      // }
      // At the moment, the endpoint outputs that error, but then just silently fails, below

      // check for extra data, and if we get any, then add it into the main data object
      let extras = Object.keys(response);
      if (extras) {
        extras.forEach(function(extra) {
          d[extra] = response[extra];
        })
      }

      // carry on with the data we found
      updatePropertySidebarDetails(d, property_attributes);
    })

  } else {
    // regular anonymous user:
    // carry on with the data we already have
    updatePropertySidebarDetails(d, property_attributes);
  }
}

// continuation of the above refresh of property sidebar, providing the same data API for both authenticated and anonymous users
function updatePropertySidebarDetails(d, property_attributes) {
  // first hide/show the appropriate panel
  $('div.sidebar-panel').removeClass('active');
  // then show what we need
  let target = $('div#sidebar-property').addClass('active');
  // start filling things in
  target.find('div#property-title').text(d.name);
  target.find('div#property-address').text(`${d.address}, ${d.cityname}, CA ${d.zipcode}`);

  // then, update the property attribute table
  target = $('div#sidebar div#sidebar-property table#property-attributes').empty();

  // update the attributes
  property_attributes.forEach(function(attribute) {
    let row = $('<tr>'); // don't append it yet, see below

    // add the left-side label
    let label = $('<span>', { text: attribute.label });

    // add a tooltip, if one is provided
    if (attribute.tooltip) {
      // add an info icon, to serve as a trigger for a tippy tooltip
      let infospan = $('<i>', {class: 'fa fa-info-circle blue', 'data-info': attribute.label}).appendTo(label);
      let html = `<b>${attribute.label}</b>: ${attribute.tooltip}`;
      tippy(infospan[0], {
        content: html,
        trigger: 'click',
        interactive: true,
        allowHTML: true,
        onShown(instance) {
         sendInfoIconGA(instance, 'Property attributes');
        }
      });      
    }

    // if there is a value, format it, otherwise, use the "no data" definition
    // furthermore, if nodata is false, set value to null so we skip this attribute completely
    let thisformat = CONFIG.format[attribute.format];
    let value = d[attribute.key] ? thisformat(d[attribute.key]) : (attribute.nodata ? attribute.nodata : null);

    // create the markup for this attribute: a label cell, and a value cell
    if (value) {
      $('<td>', {'class': 'property-attribute-title', html: label}).appendTo(row);
      let klass = attribute.key == 'tcac_opportunity' ? 'property-attribute-value tcac' : 'property-attribute-value';
      $('<td>', {'class': klass, text: value}).appendTo(row);
      row.appendTo(target); // note: if there is no value, there is nothing to append
    }
  });

  // Update the co-benefits, hiding those that are 0
  CONFIG.property_cobenefits.forEach(function(benefit) {
    if (d[benefit.key] > 0) {
      let format = benefit.format;
      let value = CONFIG.format[format](d[benefit.key]);
      $(`div#sidebar-property div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).show();
      $(`div#sidebar-property div.cobenefits-wrapper span[data-cobenefit="${benefit.key}"]`).text(value);
    } else {
      $(`div#sidebar-property div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).hide();
    }
  })

  // attach the data to the download CSV button. See initButtons() for the actual download action
  $('button#property-csv-download-button').removeData();
  $('button#property-csv-download-button').data('download', d);
}

// shared function for sending GA event when someone clicks an info icon
function sendInfoIconGA(instance, category) {
  let data = instance.reference.dataset.info;
  ga('send', 'event', 'Info Icon', category, data);
}

function updateCalculatorResultsSidebar(d) {
  // keep note of the visible panel
  CONFIG.visible_panel = 'calculator-results';

  // first hide/show the appropriate panel
  $('div.sidebar-panel').removeClass('active');
  // then show what we need
  let target = $('div#sidebar-calculator-results').addClass('active');
  // start filling things in
  let address_text = d.address ? d.address : 'Location of Dropped Pin';
  target.find('div#calculator-result-address').text(address_text);
  let lat = d.lat.toFixed(6); // truncate these, otherwise they can be ridiculously precise
  let lng = d.lng.toFixed(6);
  target.find('div#calculator-result-coordinates').text(`${lat}, ${lng}`);

  // next, update the property attribute table
  target = $('div#sidebar div#sidebar-calculator-results table#calculator-result-attributes').empty();
  CONFIG.calculator_attributes.forEach(function(attribute) {
    let row = $('<tr>'); // don't append it yet, see below

    // add the left-side label: 
    let label = $('<span>', { text: attribute.label });

    // add a tooltip, if one is provided
    if (attribute.tooltip) {
      // add an info icon, to serve as a trigger for a tippy tooltip
      let infospan = $('<i>', {class: 'fa fa-info-circle blue', 'data-info': attribute.label}).appendTo(label);
      let html = `<b>${attribute.label}</b>: ${attribute.tooltip}`;
      tippy(infospan[0], {
        content: html,
        trigger: 'click',
        interactive: true,
        allowHTML: true,
        onShown(instance) {
         sendInfoIconGA(instance, 'Calculator attributes');
        }
      });      
    }

    // if there is a value, format it, otherwise, use the "no data" definition
    // furthermore, if nodata is false, set value to null so we skip this attribute completely
    let thisformat = CONFIG.format[attribute.format];
    let value = d[attribute.key] ? thisformat(d[attribute.key]) : (attribute.nodata ? attribute.nodata : null);

    // create the markup for this attribute: a label cell, and a value cell
    if (value) {
      $('<td>', {'class': 'calculator-result-attribute-title', html: label}).appendTo(row);
      let klass = attribute.key == 'tcac_opportunity' ? 'calculator-result-attribute-value tcac' : 'calculator-result-attribute-value';
      $('<td>', {'class': klass, text: value}).appendTo(row);
      row.appendTo(target); // note: if there is no value, there is nothing to append
    }
  });

  // Update the co-benefits, hiding those that are 0
  CONFIG.calculator_cobenefits.forEach(function(benefit) {
    if (d[benefit.key] > 0) {
      let format = benefit.format;
      let value = CONFIG.format[format](d[benefit.key]);
      $(`div#sidebar-calculator-results div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).show();
      $(`div#sidebar-calculator-results div.cobenefits-wrapper span[data-cobenefit="${benefit.key}"]`).text(value);
    } else {
      $(`div#sidebar-calculator-results div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).hide();
    }
  })

  // attach the data to the download CSV button. See initButtons() for the actual download action
  $('button#calculator-csv-download-button').removeData();
  $('button#calculator-csv-download-button').data('download', d); 

}

// given a chunk of data for a district, update the sidebar
function updateDistrictSidebar(d) {
  // keep note of the visible panel
  CONFIG.visible_panel = 'district';
  CONFIG.selected.dtype = d.type;
  CONFIG.selected.id = d.id;

  // Update the values that sit next to the district radio buttons
  // rural status:
  $('td[data-status="rural"]').text(CONFIG.format.number(d['rural_count']['total']));  
  $('td[data-status="nonrural"]').text(CONFIG.format.number(d['nonrural_count']['total']));

  // funding program: 
  $('td[data-funding="hud"]').text(CONFIG.format.number(d['hud_count']['total']));
  $('td[data-funding="usda"]').text(CONFIG.format.number(d['usda_count']['total']));
  $('td[data-funding="lihtc"]').text(CONFIG.format.number(d['lihtc_count']['total']));
  $('td[data-funding="hcd"]').text(CONFIG.format.number(d['hcd_count']['total']));
  $('td[data-funding="calhfa"]').text(CONFIG.format.number(d['calhfa_count']['total']));

  // trap the nodata condition
  if (d.nodata) {
    // update the message next to the PDF button
    $('div#pdf-download-label').hide();
    $('div#pdf-download-label-nodata').show().find('span').text(d.name);

    // disable the PDF button
    $('button#pdf-download-button').prop('disabled', true);

    // remove any existing cobenefits that may be showing
    $('div.cobenefits-wrapper div.cobenefits-section').hide();

    // hide the affordable homes chart 
    $('div#chart-wrapper').hide();

    // show the nodata panel below, in cobenefits-wrapper
    $('div.cobenefits-wrapper div.nodata-panel').show();

    // that's it, we're done here
    return;

  } else {
    // reset the above things, in case they have already been triggered
    $('button#pdf-download-button').prop('disabled', false);
    $('div#pdf-download-label').show();
    $('div#pdf-download-label-nodata').hide();
    $('div.cobenefits-wrapper div.cobenefits-section').show();
    $('div#chart-wrapper').show();
    $('div.cobenefits-wrapper div.nodata-panel').hide();
  }

  // update the PDF download label
  $('div#pdf-download-label span').text(d.name);

  // Update the co-benefits, hiding those that are 0
  CONFIG.district_cobenefits.forEach(function(benefit) {
    if (d[benefit.key].total > 0) {
      let format = benefit.format;
      let value = CONFIG.format[format](d[benefit.key].total);
      $(`div#sidebar-benefits div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).show();
      $(`div#sidebar-benefits div.cobenefits-wrapper span[data-cobenefit="${benefit.key}"]`).text(value).show();
    } else {
      $(`div#sidebar-benefits div.cobenefits-wrapper div.cobenefits-section[data-cobenefit="${benefit.key}"]`).hide();
    }
  })

  // Update the chart
  // update default formatting to include 1000's separator on tooltips and axis ticks
  Chart.defaults.global.tooltips.callbacks.label = function(tooltipItem, data) {
      return tooltipItem.yLabel.toLocaleString("en-US");
  };
  Chart.scaleService.updateScaleDefaults('linear', {
      ticks: {
          callback: function (value, index, values) {
              return value.toLocaleString();
          }
      }
  });
  var chart = $('canvas#chart');
  if (CONFIG.chart) CONFIG.chart.destroy();

  // it's possible to not have a year count, for example properties in a small selection that are not yet PIS
  // in which case we shouldn't try to draw a chart
  if (d.year_count) {
    CONFIG.chart = new Chart(chart, {
        type: 'bar',
        data: {
          labels: Object.keys(d.year_count),
          datasets: [{
            data: Object.values(d.year_count),
            backgroundColor: '#25A2B6',
          }],
        },
        options: {
          legend: {display: false},
          title: {
            display: true,
            text: 'AFFORDABLE HOMES ADDED PER YEAR',
            fontFamily: '"Lato", sans-serif',
            fontSize: 13,
          },
        }
    });
  }
}

function zoomToProperty(property_id) {
  CONFIG.housing_properties.eachLayer(function(layer) {
    if (layer.id == property_id) {
      // found it, pretend we clicked it
      let latlng = layer.getLatLng();
      layer.fireEvent('click', {latlng: latlng});
      // then zoom to it
      CONFIG.map.setViewWithOffset(latlng, CONFIG.maxzoom - 3);
    }
  });
}

function zoomToDistrict(type, id) {
  // first clear any district selection
  CONFIG.selected_district.clearLayers();

  // add, filter, and restyle housing properties to give them the "regular" look
  // only necessary to clear any "owner_operator" selection, below
  if (! CONFIG.first_load) addHousingPropertiesToMap(true, false);

  if (type == 'california') {
    // zoom to the whole state
    CONFIG.map.fitBoundsWithOffset(CONFIG.homebounds);
    CONFIG.district_bounds = CONFIG.homebounds;
    CONFIG.district_json = CONFIG.ca_json;
    CONFIG.ca_border.addTo(CONFIG.map);
  } else if (type == 'owner_developer') {
    // no boundary for this one 
    CONFIG.district_json = '';

    // zoom to the bounds of this collection of owner/developer properties
    let bounds = L.latLngBounds(); 
    let count = DATA.district_sums.owner_developer[id].total_properties.total;

    // Now, we have to actually fetch the property data for this owner
    // so we can add it to the map with the "selected" property style
    let owner = DATA.owner_developer_lookup[id];
  
    // get the list of checked funding and rural status filters
    let filters = $('div#status-and-funding-options input:checkbox').map(function() {
      let self = $(this)
      if (self.is(':checked')) return self.attr('id')
    }).get();

    // set up the params we'll provide to the backend function that does that calcs  
    let params = {
      owner: owner.name, // selected owner
      filters: filters,  // the selected filters 
    }

    $.getJSON('data/owner_data', params, function(response) {
      let rawdata = response.properties;
      let fullbounds = response.bounds;

      // keep a copy of the returned data
      DATA.district_sums[type][id].rawdata = rawdata;
      let ids = rawdata.map(function(m) { return m.id + '' });
      let found = 0;
      CONFIG.housing_properties.eachLayer(function(layer) {
        if (found == count) return; // no need to continue iterating the list once we've found all of them
        // look for a match in the array of ids, with the given property id
        if ( ids.indexOf(layer.properties.id) > -1 ) {
          // found one
          found += 1; 
          layer.setStyle(CONFIG.circle_styles.circle_selected);
          layer.selected = true;
          layer.bringToFront();
          bounds.extend([ layer.properties.latitude, layer.properties.longitude ]);
        }
      });
      CONFIG.map.fitBoundsWithOffset(bounds);
      // keep a reference to the full bounds (unfiltered), to send with the PDF request
      CONFIG.district_bounds = fullbounds;
    });

  } else {
    // get the geojson for this district
    $.getJSON('./data/district_json', {dtype: type, did: id}, function(result) {
      CONFIG.district_json = JSON.parse(result);
      let layer = L.geoJson(CONFIG.district_json, {
        style: CONFIG.selected_district_style,
        interactive: false,
      }).addTo(CONFIG.selected_district);
      var bounds;
      if (type =='county' && id=='38') {
        // SF County special case: do not include Farallon Islands
        bounds = [[37.84, -122.35],[37.7,-122.52]]
      } else {
        bounds = layer.getBounds();
      }
      CONFIG.map.fitBoundsWithOffset(bounds);
      CONFIG.district_bounds = getBoundsArray(bounds);
    })
  }
}

// search is really divided into two parts
// first, find a single property: findProperty()
// second, show the results for that place on the sidebar: showPlaceSearchResults()
function findProperty(options) {
  let string = options.value;
  // do the property search
  var results = SEARCH['property'].search(string);

  // after completing the search, show the search wrapper
  $('div#property-search-results').show();
  if (results.length) {
    // show the results
    $('div#no-results').hide();
    var target = $('div#search-results').empty().show();
    // show more or fewer search result items with this index
    let items_to_show = CONFIG.search_results_max_length;
    items_to_show = items_to_show > results.length ? results.length : items_to_show - 1;

    // generate the list of search results to show below the search bar
    for (var i = 0; i < items_to_show; i++) {
      let dataid = results[i];
      let result = DATA.property_lookup[dataid];
      let wrapper = $('<div>').attr('data-id', dataid).attr('data-name', result.name).appendTo(target);
      let name = $('<p>', {text: result.name, 'class': 'result-name'}).appendTo(wrapper).mark(string);
      let address = $('<p>', {text: `${result.address}, ${result.cityname}, CA ${result.zipcode}`, 'class': 'result-address'}).appendTo(wrapper).mark(string);
    }

  } else {
    // indicate that there are no results
    $('div#search-results').hide();
    $('div#no-results').show();
  }
}

// given a placeid, return a geography type and name
function getNameFromTypeAndPlaceID(type, id) {
  // give this group a name, which is fairly conditional it turns out
  let name;
  switch (type) {
    case 'california':
      name = 'California';
      break;
    case 'county':
      name = `${DATA['county_lookup'][id].name} County`;
      break;
    case 'city':
      let city = DATA['city_lookup'][id];
      name = `${city.name} ${city.tag}`;
      break;
    case 'owner_developer':
      name = DATA['owner_developer_lookup'][id].name;
      break;
    case 'stateassembly':
    case 'statesenate':
    case 'congress':
      let lookup = `${type}_lookup`;
      name = DATA[lookup][id].name;
      break;
  }
  return name;
}

// handle and show search results on the map and sidebar
function showPlaceSearchResults(placeid, searchtype) {
  switch (searchtype) {
    case 'property':
      let property = DATA.property_lookup[placeid];
      updatePropertySidebar(property);
      zoomToProperty(placeid);
      break;

    case 'district':
      // cleanup: remove any property selection from the map
      resetMarker();

      // first look up the data that corresponds to the district
      // split the placeid to get the type and id
      let keys = placeid.split('-');
      let type = keys[0]; // e.g. 'city','county','congress' etc.
      let id = keys[1];   // e.g. '1'

      // get the summary stats for this district
      getDistrictSums(type, id).done(function(data) {
        updateDistrictSidebar(data);
        zoomToDistrict(type, id);
      });
      break; 
  }

  // update state params
  if (! CONFIG.first_load ) updateSearchParams();
}

// generic function to make and download a CSV given values, fields, and a filename
function makeCsvDownload(values, fields, filename) {
  const csv = Papa.unparse({
    'data': values,
    'fields': fields
  });

  // now use Blob to create the download
  const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
  var url =  null;
  if (navigator.msSaveBlob) {
    url = navigator.msSaveBlob(blob, 'property_benefits.csv');
  } else {
    url = window.URL.createObjectURL(blob);
  }

  // create a link, set the download attribute and url
  const a = document.createElement('a');
  a.setAttribute('download', filename);
  a.href = url;

  // apend the link, click it, and then remove the link from the DOM
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// primary function for calculating sums and totals for a given geography
function getDistrictSums(type='california', id='california') {
  // get the list of checked funding and rural status filters
  let filters = $('div#status-and-funding-options input:checkbox').map(function() {
    let self = $(this)
    if (self.is(':checked')) return self.attr('id')
  }).get();

  // set up the params we'll provide to the backend function that does that calcs  
  let params = {
    dtype: type,       // selected district type, e.g. 'stateassembly'
    did: id,           // selected distirict id  
    filters: filters,  // the selected filters 
  }

  // fetch the remote sums and totals
  return $.getJSON('data/district_sums', params, function(data) {
    // save a copy of the results
    // TO DO: this cache- what about when there are filter params?? we don't want to cache and use that, do we? 
    // A: yes and no. Some of the stats and metadata are the same regardless 
    //    and some stats (['total_affordable']['total'] and ['total_properties']['total']) are calculated independent of filters
    //    We just have to be careful about what we are using, where
    DATA.district_sums[type][id] = data;
    
    // give this group a name
    let name = getNameFromTypeAndPlaceID(type, id);
    DATA.district_sums[type][id].name = name;

    // update the message by the filters showing how many affordable homes are in the set
    let count = data.affordable_units_count_filtered || 0;
    let totalhomes_raw = DATA.district_sums[type][id]['total_affordable']['total'];
    let totalhomes = CONFIG.format.number(totalhomes_raw);
  
    let message, target = $('div#filter-total-homes-message').empty();
    let funding_checks = $('input[name="funding_status"]:checked').length;
    let status_checks = $('input[name="rural_status"]:checked').length;

    if (count == 0 && totalhomes == '0') {
      message = 'No affordable homes';
    } else if (count == 0) {
      message = `Showing 0 out of ${totalhomes} total affordable homes`;
    } else if (count && (count != totalhomes_raw)) {
      let thishomes = CONFIG.format.number(count);
      message = `Showing ${thishomes} out of ${totalhomes} total affordable homes`;
    } else if (count && (count == totalhomes_raw)) {
      message = `Showing all ${totalhomes} affordable homes`;
    } else {
      message = `Showing ${totalhomes} total affordable homes`;
    }
    target.text(message);
  }) // $.get
} // getDistrictSums

// update the state params in the address bar to reflect current params and options
function updateSearchParams() {
  // listen for changes to the map and update zoom, extent params
  // get the current search params
  let params = new URLSearchParams(window.location.search);

  // the view
  let zoom   = CONFIG.map.getZoom();
  let center = CONFIG.map.getCenter();
  let view = `${center.lat.toPrecision(8)},${center.lng.toPrecision(8)},${zoom}`;
  params.delete('view');
  params.append('view', view);

  // selected tract layers
  let tract = $('input[name="underlays"]:checked').val();
  params.delete('tract');
  // don't bother to add it if this is null (no layer) - we don't need to carry around a param for 'null'
  if (tract) params.append('tract', tract);

  // selected boundary layer
  params.delete('boundary');
  let boundary = $('input[name="boundaries"]:checked').val();
  // don't bother adding it if this is null
  if (boundary) params.append('boundary', boundary);

  // selected rural status
  params.delete('rural');
  let rural = $('input[name="rural_status"]:checked').map(function() { return $(this).val(); }).get().join();
  params.append('rural', rural);

  // selected funding program
  params.delete('funding');
  let funding = $('input[name="funding_status"]:checked').map(function() { return $(this).val(); }).get().join();
  params.append('funding', funding);

  // selected property or district, can't have both, it's one or the other
  params.delete('selected');
  // california is the default, don't add a param for it
  if ( ! $.isEmptyObject(CONFIG.selected) && CONFIG.selected.dtype != 'california') {
    let selected = `${CONFIG.selected.dtype},${CONFIG.selected.id}`;
    params.append('selected', selected);
  }

  // calculator
  params.delete('calculator'); 
  if ($('button#btn-calculator').hasClass('selected')) params.append('calculator', true);

  // all set! if we have anything, parse the string, make it a query and
  // replace state in our local address bar
  let searchstring = decodeURIComponent(params.toString());
  if (searchstring) {
    var newparams = '?' + searchstring;
    window.history.replaceState(newparams, '', newparams);
  }

  // final step: Let the iframe know the new params
  // so we can get this on the address bar of the parent page
  parent.postMessage(newparams, '*');
}

///////////////////////////////////////////////////////////////////////////////////
// Shims and utilities
///////////////////////////////////////////////////////////////////////////////////

// get bounds as a simple array
function getBoundsArray(bounds) {
  let ne = bounds.getNorthEast();
  let sw = bounds.getSouthWest();
  let array = [[sw.lat, sw.lng], [ne.lat, ne.lng]];
  return array;
}

// hacks to define whether we should "act mobile" in ways that can only be known at runtime
var isMobile = function() { return $(window).width() <= 768; }();
var isLaptop = function() { return $(window).width() <= 1200; }();

/**
 * The "median" is the "middle" value in the list of numbers.
 *
 * @param {Array} numbers An array of numbers.
 * @return {Number} The calculated median value from the specified numbers.
 */
function median(numbers) {
    // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
    var median = 0, numsLen = numbers.length;
    numbers.sort((a, b) => a - b); // For ascending sort

    if (
        numsLen % 2 === 0 // is even
    ) {
        // average of two middle numbers
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
    } else { // is odd
        // middle number only
        median = numbers[(numsLen - 1) / 2];
    }

    return median;
}

// shim for Object.values
Object.values = Object.values || (obj => Object.keys(obj).map(key => obj[key]));

// wait for a variable to exist. When it does, fire the given callback
function waitForIt(key, callback) {
  if (key) {
    callback();
  } else {
    setTimeout(function() {
      waitForIt(key, callback);
    }, 100);
  }
};